import * as CONSTANT from './../base/constant';
import { createElement, detach, prepend, append, attributes, Browser, addClass, removeClass } from '@syncfusion/ej2-base';
import { markerClassName } from './dom-node';
import * as EVENTS from './../../common/constant';
import { setStyleAttribute } from '@syncfusion/ej2-base';
import { isIDevice, setEditFrameFocus } from '../../common/util';
import { isNullOrUndefined, isNullOrUndefined as isNOU, closest } from '@syncfusion/ej2-base';
import { InsertHtml } from './inserthtml';
import { DOMMethods } from './dom-tree';
/**
 * Lists internal component
 *
 * @hidden
 * @private
 */
export class Lists {
    /**
     * Constructor for creating the Lists plugin
     *
     * @param {EditorManager} parent - specifies the parent element
     * @hidden
     * @private
     */
    constructor(parent) {
        this.listTabIndentation = false;
        this.parent = parent;
        this.domNode = this.parent.domNode;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(EVENTS.LIST_TYPE, this.applyListsHandler, this);
        this.parent.observer.on(EVENTS.KEY_UP_HANDLER, this.onKeyUp, this);
        this.parent.observer.on(EVENTS.KEY_DOWN_HANDLER, this.keyDownHandler, this);
        this.parent.observer.on(EVENTS.SPACE_ACTION, this.spaceKeyAction, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(EVENTS.LIST_TYPE, this.applyListsHandler);
        this.parent.observer.off(EVENTS.KEY_UP_HANDLER, this.onKeyUp);
        this.parent.observer.off(EVENTS.KEY_DOWN_HANDLER, this.keyDownHandler);
        this.parent.observer.off(EVENTS.SPACE_ACTION, this.spaceKeyAction);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    }
    testList(elem) {
        const olListRegex = [/^[\d]+[.]+$/,
            /^(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})[.]$/gi,
            /^[a-zA-Z][.]+$/];
        const elementStart = !isNullOrUndefined(elem) ? elem.innerText.trim().split('.')[0] + '.' : null;
        if (!isNullOrUndefined(elementStart)) {
            for (let i = 0; i < olListRegex.length; i++) {
                if (olListRegex[i].test(elementStart)) {
                    return true;
                }
            }
        }
        return false;
    }
    isOrderedList(range) {
        const olListStartRegex = [/^[1]+[.]+$/, /^[i]+[.]+$/, /^[a]+[.]+$/];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            const editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (let i = 0; i < olListStartRegex.length; i++) {
                if (olListStartRegex[i].test(editorValue) && editorValue.length === 2) {
                    return true;
                }
            }
        }
        return false;
    }
    isUnOrderedList(range) {
        const ulListStartRegex = [/^[*]$/, /^[-]$/];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            const editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (let i = 0; i < ulListStartRegex.length; i++) {
                if (ulListStartRegex[i].test(editorValue)) {
                    return true;
                }
            }
        }
        return false;
    }
    isCheckList(range) {
        // Updated regex to match checkbox patterns with at most one space: [], [x], [ ], [x ], [ x], [ x ]
        const ulListStartRegex = [/^\[\s?\]$/, /^\[\s?x\s?\]$/i];
        if (!isNullOrUndefined(range.startContainer.textContent.slice(0, range.startOffset))) {
            const editorValue = range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim();
            for (let i = 0; i < ulListStartRegex.length; i++) {
                if (ulListStartRegex[i].test(editorValue)) {
                    return true;
                }
            }
        }
        return false;
    }
    createAutoList(enterKey, shiftEnterKey) {
        const autoListRules = {
            BR: { BR: true, P: true, DIV: true },
            P: { BR: false, P: true, DIV: true },
            DIV: { BR: false, P: true, DIV: true }
        };
        if (autoListRules[enterKey] && autoListRules[enterKey][shiftEnterKey] !== undefined) {
            return autoListRules[enterKey][shiftEnterKey];
        }
        return false;
    }
    isInsideSameListType(startNode, range) {
        if (!startNode) {
            return false;
        }
        // Find the closest <li> ancestor of the startNode
        const listItem = startNode.closest('li');
        if (!listItem) {
            return false; // Not inside a list item
        }
        // Get the parent list element (either <ul> or <ol>)
        const parentList = listItem.closest('ul, ol');
        if (!parentList) {
            return false; // No valid list container found
        }
        // Check if parentList is OL or UL and compare with startElementOLTest
        if (this.isOrderedList(range) && parentList.tagName === 'OL') {
            return true;
        }
        else if (this.isUnOrderedList(range) && parentList.tagName === 'UL' && !parentList.classList.contains('e-rte-checklist')) {
            return true;
        }
        else if (this.isCheckList(range) && parentList.tagName === 'UL' && parentList.classList.contains('e-rte-checklist')) {
            return true;
        }
        else {
            return false;
        }
    }
    spaceList(e) {
        const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
        if (!this.parent.isAtStart()) {
            return;
        }
        const startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        // eslint-disable-next-line
        const endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        const preElement = startNode.previousElementSibling;
        const nextElement = startNode.nextElementSibling;
        const preElemULStart = !isNullOrUndefined(preElement) ?
            preElement.innerText.trim().substring(0, 1) : null;
        const nextElemULStart = !isNullOrUndefined(nextElement) ?
            nextElement.innerText.trim().substring(0, 1) : null;
        const startElementOLTest = this.isOrderedList(range);
        const preElementOLTest = this.testList(preElement);
        const nextElementOLTest = this.testList(nextElement);
        const isInsideSameListType = this.isInsideSameListType(startNode, range);
        const nextElementBRTest = range.startContainer.previousElementSibling && range.startContainer.previousElementSibling.tagName === 'BR';
        if (!isInsideSameListType && !preElementOLTest && !nextElementOLTest && preElemULStart !== '*' && nextElemULStart !== '*' && (this.createAutoList(e.enterKey, e.shiftEnterKey) || !nextElementBRTest)) {
            const brElement = createElement('br');
            if (startElementOLTest) {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'OL', callBack: e.callBack, enterAction: e.enterKey });
                e.event.preventDefault();
            }
            else if (range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim() === '*' ||
                range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim() === '-') {
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'UL', callBack: e.callBack, enterAction: e.enterKey });
                e.event.preventDefault();
            }
            else if (this.isCheckList(range)) {
                const isChecked = /^\[\s*x\s*\]$/i.test(range.startContainer.textContent.replace(/\u200B/g, '').slice(0, range.startOffset).trim());
                range.startContainer.textContent = range.startContainer.textContent.slice(range.startOffset, range.startContainer.textContent.length);
                if (range.startContainer.nodeName === '#text' && range.startContainer.textContent.length === 0) {
                    this.parent.domNode.insertAfter(brElement, range.startContainer);
                }
                this.applyListsHandler({ subCommand: 'Checklist', callBack: e.callBack, enterAction: e.enterKey }, isChecked);
                e.event.preventDefault();
            }
        }
    }
    isCtrlEnterInChecklist(e) {
        let storeIntoStack = false;
        if (e.event && (e.event.ctrlKey || e.event.metaKey) && e.event.key === 'Enter' && e.event.action === 'checklist-toggle') {
            const domMethods = new DOMMethods(this.parent.editableElement);
            const li = domMethods.getLiElementsInRange();
            for (let i = 0; i < li.length; i++) {
                if (li[i].nodeName === 'LI' && li[i].parentElement.nodeName === 'UL'
                    && !li[i].classList.contains('e-rte-checklist-hidden')
                    && li[i].parentElement.classList.contains('e-rte-checklist')) {
                    storeIntoStack = true;
                    if (li[i].classList.contains('e-rte-checklist-checked')) {
                        li[i].classList.remove('e-rte-checklist-checked');
                    }
                    else {
                        li[i].classList.add('e-rte-checklist-checked');
                    }
                }
            }
        }
        if (storeIntoStack) {
            if (e.callBack) {
                e.callBack({
                    requestType: this.currentAction,
                    editorMode: 'HTML',
                    range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                    elements: this.parent.domNode.blockNodes(),
                    event: e.event
                });
            }
            storeIntoStack = false;
        }
    }
    enterList(e) {
        const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const startNode = range.startContainer.nodeName === 'LI' ? range.startContainer :
            range.startContainer.parentElement.closest('LI');
        const endNode = range.endContainer.nodeName === 'LI' ? range.endContainer :
            range.endContainer.parentElement.closest('LI');
        // Command handler for Ctrl+Enter or Cmd+Enter checklist toggle
        this.isCtrlEnterInChecklist(e);
        let hasMediaElem = false;
        if (!isNOU(startNode)) {
            const videoElemList = startNode.querySelectorAll('.e-video-clickelem');
            const embedVideoElem = videoElemList.length > 0 && videoElemList[0].childNodes[0].nodeName === 'IFRAME';
            hasMediaElem = startNode.querySelectorAll('IMG').length > 0 || startNode.querySelectorAll('AUDIO').length > 0 || startNode.querySelectorAll('VIDEO').length > 0 || embedVideoElem;
        }
        let startNodeParent;
        let parentOfCurrentOLUL;
        if (startNode) {
            startNodeParent = startNode.parentElement;
            if (startNodeParent) {
                parentOfCurrentOLUL = startNodeParent.parentElement;
            }
        }
        const tableElement = !isNullOrUndefined(startNode) ? startNode.querySelector('TABLE') : null;
        if (!isNOU(startNode) && !isNOU(endNode) && startNode === endNode && startNode.tagName === 'LI' &&
            startNode.textContent.trim() === '' && !hasMediaElem && isNOU(tableElement)) {
            if (startNode.innerHTML.indexOf('&nbsp;') >= 0) {
                return;
            }
            if (startNode.textContent.charCodeAt(0) === 65279) {
                startNode.textContent = '';
            }
            if (isNOU(parentOfCurrentOLUL.closest('UL')) && isNOU(parentOfCurrentOLUL.closest('OL'))) {
                if (!isNOU(startNode.nextElementSibling)) {
                    const nearBlockNode = this.parent.domNode.blockParentNode(startNode);
                    this.parent.nodeCutter.GetSpliceNode(range, nearBlockNode);
                }
                let insertTag;
                if (e.enterAction === 'DIV') {
                    insertTag = createElement('div');
                    insertTag.innerHTML = '<br>';
                }
                else if (e.enterAction === 'P') {
                    insertTag = createElement('p');
                    insertTag.innerHTML = '<br>';
                }
                else {
                    insertTag = createElement('br');
                }
                const immediateBlock = this.domNode.getImmediateBlockNode(range.startContainer);
                const { formattedElement, cursorTarget } = this.applyFormattingFromRange(insertTag, range, immediateBlock, e.enterAction);
                insertTag = formattedElement;
                if (!isNOU(parentOfCurrentOLUL) && parentOfCurrentOLUL.nodeName === 'BLOCKQUOTE') {
                    this.parent.observer.notify('blockquote_list_handled', {});
                }
                this.parent.domNode.insertAfter(insertTag, startNodeParent);
                e.event.preventDefault();
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorTarget, 0);
                if (startNodeParent.textContent === '' && (startNodeParent.querySelectorAll('audio,video,table').length === 0)) {
                    detach(startNodeParent);
                }
                else {
                    detach(startNode);
                }
            }
            // To handle the nested enter key press in the list for the first LI element
            if (!isNOU(parentOfCurrentOLUL) && (!isNOU(parentOfCurrentOLUL.closest('UL')) || !isNOU(parentOfCurrentOLUL.closest('OL'))) &&
                parentOfCurrentOLUL.nodeName === 'LI' && parentOfCurrentOLUL.style.listStyleType === 'none' &&
                parentOfCurrentOLUL.textContent === '' && startNode.textContent === '' && startNode === startNodeParent.firstElementChild &&
                isNOU(startNode.nextSibling)) {
                detach(startNodeParent);
                parentOfCurrentOLUL.style.removeProperty('list-style-type');
                e.event.preventDefault();
            }
        }
        const startContainer = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement : range.startContainer;
        const isCloseTableOrEditableElem = this.isNodeInListNotTable(startContainer);
        if (!isNOU(startNode) && !isNOU(endNode) && startNode === endNode && startNode.tagName === 'LI' && startNode.textContent.length !== 0 && isCloseTableOrEditableElem && e.event && !e.event.shiftKey && !(e.event.ctrlKey || e.event.metaKey)) {
            this.splitListAtCursor(range, startNode, startNodeParent);
            e.event.preventDefault();
            return;
        }
        this.handleNestedEnterKeyForLists(e, parentOfCurrentOLUL, startNode, startNodeParent);
    }
    /*
    * Splits a list item at the cursor position, creating a new list item with content after the cursor.
    * This method handles both simple and complex list structures, including nested lists.
    */
    splitListAtCursor(range, startNode, startNodeParent) {
        const newRange = this.parent.editableElement.ownerDocument.createRange();
        const selfClosingElements = ['AREA', 'BASE', 'BR', 'COL', 'EMBED', 'HR', 'IMG', 'INPUT', 'LINK', 'META', 'SOURCE', 'TRACK', 'WBR'];
        const startContainer = range.startContainer;
        const startOffset = range.startOffset;
        let clonedContent;
        if (range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
            newRange.setStart(startContainer, startOffset);
            newRange.setEndAfter(startNode);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
            const getNewRange = this.parent.nodeSelection.getRange(this.parent.editableElement.ownerDocument);
            clonedContent = getNewRange.cloneContents();
            this.cleanupListElements(clonedContent, selfClosingElements);
            newRange.deleteContents();
        }
        else {
            range.deleteContents();
            newRange.setStart(startContainer, startOffset);
            newRange.setEndAfter(startNode);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
            const getNewRange = this.parent.nodeSelection.getRange(this.parent.editableElement.ownerDocument);
            clonedContent = getNewRange.cloneContents();
            this.cleanupListElements(clonedContent, selfClosingElements);
            newRange.deleteContents();
        }
        if (startNode.querySelectorAll('*:empty').length > 0) {
            const emptyElem = startNode.querySelectorAll('*:empty');
            for (let i = 0; i < emptyElem.length; i++) {
                if (selfClosingElements.indexOf(emptyElem[i].nodeName) === -1) {
                    detach(emptyElem[i]);
                }
            }
        }
        if (startNode.innerHTML === '') {
            startNode.innerHTML = '<br>';
        }
        clonedContent.normalize();
        // Remove explicit `value` attributes from the cloned fragment so browser auto-numbers correctly after insertion
        const fragmentList = clonedContent.querySelectorAll('li');
        for (let i = 0; i < fragmentList.length; i++) {
            if (fragmentList[i].hasAttribute('value')) {
                fragmentList[i].removeAttribute('value');
            }
        }
        const firstPosition = this.parent.nodeSelection.findFirstContentNode(clonedContent);
        if (startNode.nextElementSibling) {
            startNodeParent.insertBefore(clonedContent, startNode.nextElementSibling);
        }
        else {
            startNodeParent.appendChild(clonedContent);
        }
        if (firstPosition.node.nodeName === 'BR') {
            const newRange = this.parent.editableElement.ownerDocument.createRange();
            newRange.setStartBefore(firstPosition.node);
            newRange.setEndBefore(firstPosition.node);
            this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
        }
        else {
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, firstPosition.node, 0);
        }
    }
    /*
    * Cleans up empty elements within list content and ensures proper structure.
    * This method removes empty elements and adds necessary <br> elements for proper display.
    */
    cleanupListElements(content, selfClosingElements) {
        // Find and remove empty elements
        const liElement = content.firstElementChild;
        const emptyElement = liElement.querySelectorAll('*:empty');
        for (let i = 0; i < emptyElement.length - 1; i++) {
            if (selfClosingElements.indexOf(emptyElement[i].nodeName) === -1) {
                detach(emptyElement[i]);
            }
        }
        this.ensureListItemContent(content);
    }
    /*
     * Ensures list items have proper content by adding <br> elements to empty list items or to list items that only contain nested lists.
     */
    ensureListItemContent(content) {
        const listItems = content.querySelectorAll('li');
        for (let i = 0; i < listItems.length; i++) {
            const li = listItems[i];
            // Check if list item has no text content or only contains nested lists
            const hasOnlyLists = li.childNodes.length > 0 && (this.parent.domNode.isList(li.childNodes[0]) ||
                (li.childNodes[0] && li.childNodes[1] && li.childNodes[0].nodeName === '#text' && li.childNodes[0].textContent.trim() === '' &&
                    this.parent.domNode.isList(li.childNodes[1])));
            if (hasOnlyLists || li.innerHTML === '') {
                const brElement = document.createElement('br');
                if (li.firstChild) {
                    li.insertBefore(brElement, li.firstChild);
                }
                else {
                    li.appendChild(brElement);
                }
            }
            else {
                const emptyElement = li.querySelector('*:empty');
                if (emptyElement) {
                    emptyElement.appendChild(document.createElement('br'));
                }
            }
        }
    }
    /*
     * Checks if a node is inside a table or list element.
     * Returns true if the node is inside a list and not inside a table.
     * Returns false if the node is inside a table or not inside a list element.
     */
    isNodeInListNotTable(node) {
        let currentNode = node;
        // Traverse up the DOM tree until reaching the editable element or body
        while (currentNode && currentNode !== this.parent.editableElement) {
            if (currentNode.nodeName === 'TABLE') {
                // If a table is found, return false regardless of whether a list is found or not
                return false;
            }
            else if ((currentNode.nodeName === 'UL' || currentNode.nodeName === 'OL')) {
                // Mark that we found a list element
                return true;
            }
            currentNode = currentNode.parentNode;
        }
        // Return true only if a list was found and no table was encountered
        return false;
    }
    applyFormattingFromRange(element, range, blockNode, enterAction) {
        let cursorTarget = element;
        const formatTags = [];
        if (blockNode) {
            let currentNode = range.startContainer;
            const blockElements = ['div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'ul', 'ol', 'table', 'tr', 'td', 'th'];
            while (currentNode && currentNode !== blockNode) {
                const nodeName = currentNode.nodeName.toLowerCase();
                if (blockElements.indexOf(nodeName) === -1 && currentNode.nodeType === Node.ELEMENT_NODE) {
                    formatTags.push({
                        tag: nodeName,
                        element: currentNode
                    });
                }
                currentNode = currentNode.parentNode;
            }
            if (formatTags.length > 0) {
                element = (enterAction === 'BR') ? createElement('DIV') : element;
                element.innerHTML = '';
                let currentElement = element;
                formatTags.reverse().forEach((format) => {
                    const newElement = createElement(format.tag);
                    Array.from(format.element.attributes).forEach((attr) => {
                        newElement.setAttribute(attr.name, attr.value);
                    });
                    currentElement.appendChild(newElement);
                    currentElement = newElement;
                });
                const brElement = createElement('br');
                currentElement.appendChild(brElement);
                cursorTarget = currentElement;
            }
        }
        return { formattedElement: (enterAction === 'BR' && formatTags.length > 0) ? element.firstChild : element, cursorTarget };
    }
    handleNestedEnterKeyForLists(e, parentOfCurrentOLUL, startNode, startNodeParent) {
        let hasIgnoredElement = false;
        if (!isNOU(startNode) && startNode.querySelectorAll('audio,video,table,img,HR').length > 0) {
            hasIgnoredElement = true;
        }
        if (!isNOU(parentOfCurrentOLUL) && (!isNOU(parentOfCurrentOLUL.closest('UL')) || !isNOU(parentOfCurrentOLUL.closest('OL')) || startNodeParent.nodeName === 'UL' || startNodeParent.nodeName === 'OL') &&
            (parentOfCurrentOLUL.nodeName === 'LI' || startNode.nodeName === 'LI') && (parentOfCurrentOLUL.style.listStyleType === 'none' || parentOfCurrentOLUL.style.listStyleType === '') &&
            parentOfCurrentOLUL.textContent !== '' && (!isNOU(startNode.lastElementChild) && startNode.lastElementChild.textContent !== '') && startNode.firstElementChild && (startNode.firstElementChild.textContent === '' && !hasIgnoredElement) && (startNode === startNodeParent.firstElementChild || startNode.nodeName === 'LI')) {
            const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            this.domNode.setMarker(this.saveSelection);
            e.event.preventDefault();
            const nodes = [];
            if (startNode === startNodeParent.firstElementChild) {
                nodes.push(startNodeParent.firstElementChild);
            }
            else if (startNode.nodeName === 'LI') {
                nodes.push(startNode);
            }
            this.revertList(nodes, e);
            this.revertClean();
            this.saveSelection = this.domNode.saveMarker(this.saveSelection);
            this.saveSelection.restore();
        }
    }
    /* Shifts all child nodes of currentLiElement into the deepest last non-block descendant of targetLiElement, then removes currentLiElement from the DOM. */
    shiftNestedListChildren(currentLiElement, targetLiElement) {
        // Get the deepest last non-block descendant of targetLiElement
        let insertionPoint = this.parent.domNode.getDeepestLastInlineNode(targetLiElement);
        const insertionParent = insertionPoint.parentElement;
        const isInsertionPointBR = insertionPoint.nodeName === 'BR' && insertionParent.textContent.length === 0;
        // If the blockNodes root is not the current LI, move its children
        this.moveBlockNodeChildrenToInsertionParent(currentLiElement, insertionParent);
        // Move all child nodes from currentLiElement to insertionParent
        while (!isNOU(currentLiElement.firstChild)) {
            insertionParent.appendChild(currentLiElement.firstChild);
        }
        while (insertionPoint.hasChildNodes()) {
            // to get last child node to place cursor point
            insertionPoint = insertionPoint.lastChild;
        }
        if (isInsertionPointBR) {
            // when br element is first child of li element
            detach(insertionPoint);
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, insertionParent, 0);
        }
        else {
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, insertionPoint, insertionPoint.textContent.length);
        }
        // Remove currentLiElement from the DOM if it is now empty
        if (!isNOU(currentLiElement.parentNode)) {
            currentLiElement.parentNode.removeChild(currentLiElement);
        }
    }
    /* Moves all children of the first block node (if not currentLiElement) to the insertion parent. */
    moveBlockNodeChildrenToInsertionParent(currentLiElement, insertionParent) {
        const blockNodes = this.parent.domNode.blockNodes();
        if (blockNodes[0] && blockNodes[0] !== currentLiElement) {
            let rootBlock = blockNodes[0];
            if (rootBlock.textContent.length !== 0) {
                const childNodes = Array.from(rootBlock.childNodes);
                for (let i = 0; i < childNodes.length; i++) {
                    insertionParent.appendChild(childNodes[i]);
                }
            }
            while (rootBlock.parentElement !== currentLiElement) {
                rootBlock = rootBlock.parentElement;
            }
            currentLiElement.removeChild(rootBlock);
        }
    }
    backspaceList(e) {
        const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        let startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        let endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        startNode = startNode.nodeName === 'BR' ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === 'BR' ? endNode.parentElement : endNode;
        if (!isNOU(startNode) && startNode.closest('li')) {
            const listCursorInfo = this.getListCursorInfo(range);
            const isFirst = startNode.closest('li').previousElementSibling === null;
            const allowedCursorSelections = ['StartParent'];
            const allowedSelections = ['SingleFull', 'MultipleFull'];
            const blockNodes = this.parent.domNode.blockNodes();
            const isAllListSelected = this.isAllListNodesSelected(startNode.closest('li').parentElement);
            const hasIndent = listCursorInfo.position === 'StartNested' && startNode && startNode.parentElement &&
                startNode.parentElement.closest('li') && startNode.parentElement.closest('li').getAttribute('style')
                && startNode.parentElement.closest('li').getAttribute('style').indexOf('list-style-type: none;') !== -1;
            if (isFirst && (allowedCursorSelections.indexOf(listCursorInfo.position) > -1 || hasIndent)) {
                e.event.preventDefault();
                let saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
                this.domNode.setMarker(saveSelection);
                for (let i = 0; i < blockNodes.length; i++) {
                    if (blockNodes.length > 0 && blockNodes[i].tagName !== 'LI'
                        && blockNodes[i].parentNode.tagName === 'LI') {
                        blockNodes[i] = blockNodes[i].parentNode;
                    }
                }
                this.revertList([blockNodes[0]], e);
                this.revertClean();
                saveSelection = this.domNode.saveMarker(saveSelection);
                saveSelection.restore();
                return;
            }
            else if (allowedSelections.indexOf(listCursorInfo.selectionState) > -1 && isAllListSelected) {
                e.event.preventDefault();
                blockNodes[0].innerHTML = '';
                range.deleteContents();
                if (blockNodes.length > 1) {
                    for (let i = 0; i < blockNodes.length; i++) {
                        if (i === 0) {
                            continue; // First List is needed after the removal of list items.
                        }
                        const list = blockNodes[i];
                        detach(list);
                    }
                }
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, blockNodes[0], 0);
                return;
            }
        }
        if (startNode === endNode && !isNullOrUndefined(closest(startNode, 'li')) &&
            ((startNode.textContent.trim() === '' && startNode.textContent.charCodeAt(0) === 65279) ||
                (startNode.textContent.length === 1 && startNode.textContent.charCodeAt(0) === 8203))) {
            startNode.textContent = '';
        }
        if (startNode === endNode && startNode.tagName === 'LI' && startNode.textContent.length === 0 &&
            isNOU(startNode.previousElementSibling)) {
            startNode.removeAttribute('style');
        }
        const closestListParent = startNode.nodeType === Node.TEXT_NODE ? startNode.parentElement.closest('li') : startNode.closest('li');
        const isRangeAtListStart = startNode === endNode && !isNOU(closestListParent) &&
            this.isAtListStart(closestListParent, range) && !isNOU(closestListParent.querySelector('ul, ol'));
        if (isRangeAtListStart) {
            const previousLIElement = !isNOU(closestListParent.previousSibling) && closestListParent.nodeName === 'LI' ?
                closestListParent.previousElementSibling : null;
            if (!isNOU(previousLIElement)) {
                e.event.preventDefault();
                // to shift the cursor positioned li element child nodes to previous li element
                this.shiftNestedListChildren(closestListParent, previousLIElement);
            }
            else {
                const currentList = startNode.closest('ul, ol');
                const parentListItem = currentList.parentElement;
                const prevSibling = startNode.previousElementSibling;
                const nestedList = startNode.querySelector('ol, ul');
                if (((!isNOU(parentListItem) && parentListItem.tagName === 'LI' && !isNOU(currentList.previousSibling)) || (!isNOU(prevSibling) && prevSibling.nodeName === 'LI'))) {
                    if (!isNOU(nestedList) && (isNOU(prevSibling) || !isNOU(prevSibling))) {
                        e.event.preventDefault();
                        // Preventing a default content editable div behaviour and Handles rearrangement of nested lists when press the backspace while the cursor is at the nested list structure and also redistributes child nodes and maintains cursor position after rearrangement
                        this.handleNestedListRearrangement(startNode, currentList, parentListItem, prevSibling, nestedList);
                    }
                }
            }
        }
        this.removeList(range, e);
    }
    hasMediaElement(element) {
        if (!element) {
            return false;
        }
        const videoElemList = element.querySelectorAll('.e-video-clickelem');
        const embedVideoElem = videoElemList.length > 0 && videoElemList[0].childNodes[0].nodeName === 'IFRAME';
        if (element.querySelectorAll('audio,video,table,img,hr').length > 0 || ['AUDIO', 'VIDEO', 'TABLE', 'IMG', 'HR'].indexOf(element.tagName) !== -1 || embedVideoElem) {
            return true;
        }
        return false;
    }
    handleNestedListRearrangement(startNode, currentList, parentListItem, prevSibling, nestedList) {
        const cursorOffset = this.parent.nodeSelection.findLastTextPosition(!isNOU(prevSibling) ? prevSibling : currentList.previousSibling);
        const childNodes = Array.from(startNode.childNodes);
        for (let i = 0; i < childNodes.length; i++) {
            const child = childNodes[i];
            if (child === nestedList && nestedList) {
                while (nestedList.firstChild) {
                    currentList.insertBefore(nestedList.firstChild, startNode);
                    const emptyOL = startNode.querySelector('OL:empty,UL:empty');
                    if (emptyOL) {
                        startNode.remove();
                    }
                }
            }
            else {
                if (!isNOU(prevSibling)) {
                    cursorOffset.node.parentElement.closest('li').appendChild(child);
                }
                else {
                    parentListItem.insertBefore(child, currentList);
                }
            }
        }
        this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorOffset.node, cursorOffset.offset);
    }
    findPreviousElementForCursor(currentElement) {
        let previousNode = null;
        // Try to find a previous sibling first
        if (currentElement.previousElementSibling) {
            previousNode = currentElement.previousElementSibling;
        }
        // If no previous sibling, try the parent (if not the editable element itself)
        else if (currentElement.parentElement && currentElement.parentElement !== this.parent.editableElement) {
            previousNode = currentElement.parentElement;
        }
        return previousNode;
    }
    handleCursorPositioningAfterListRemoval(previousNode) {
        if (!previousNode) {
            return;
        }
        // For Safari, explicitly set the cursor position
        if (this.parent.userAgentData.isSafari()) {
            const cursorPosition = this.parent.nodeSelection.findLastTextPosition(previousNode);
            if (cursorPosition) {
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, cursorPosition.node, cursorPosition.offset);
            }
            else {
                // If we can't find a text position, place at the end of the element
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, previousNode, previousNode.childNodes.length);
            }
        }
    }
    removeList(range, e) {
        let startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
        let endNode = (!isNOU(range.endContainer.parentElement.closest('li')) && range.endContainer.parentElement.closest('li').childElementCount > 1 && range.endContainer.nodeName === '#text') ? range.endContainer : this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
        let parentList = (range.startContainer.nodeName === '#text') ? range.startContainer.parentElement.closest('li') : range.startContainer.closest('li');
        const endParentList = (range.endContainer.nodeName === '#text') ? range.endContainer.parentElement.closest('li') : range.endContainer.closest('li');
        let fullContent = '';
        if (!isNOU(parentList) && !isNOU(parentList.firstChild)) {
            parentList.childNodes.forEach((e) => {
                fullContent = fullContent + e.textContent;
            });
        }
        startNode = startNode.nodeName === 'BR' ? startNode.parentElement : startNode;
        endNode = endNode.nodeName === 'BR' ? endNode.parentElement : endNode;
        startNode = startNode.nodeName !== 'LI' && !isNOU(startNode.closest('LI')) ? startNode.closest('LI') : startNode;
        endNode = endNode.nodeName !== 'LI' && endNode.nodeName !== '#text' && !isNOU(endNode.closest('LI')) ? endNode.closest('LI') : endNode;
        const endNodeNextElementSibling = (!isNOU(endParentList) && isNOU(endParentList.nextElementSibling));
        if (((range.commonAncestorContainer.nodeName === 'OL' || range.commonAncestorContainer.nodeName === 'UL' || range.commonAncestorContainer.nodeName === 'LI') &&
            isNOU(endNode.nextElementSibling) && endNode.textContent.length === range.endOffset && endNodeNextElementSibling &&
            isNOU(startNode.previousElementSibling) && range.startOffset === 0) ||
            (Browser.userAgent.indexOf('Firefox') !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement &&
                range.startOffset === 0 && range.endOffset === 1)) {
            // Find where to place the cursor before removing elements for safari
            let previousNode;
            if (Browser.userAgent.indexOf('Firefox') !== -1) {
                previousNode = this.findPreviousElementForCursor(range.commonAncestorContainer.childNodes[0]);
                detach(range.commonAncestorContainer.childNodes[0]);
            }
            else if (range.commonAncestorContainer.nodeName === 'LI') {
                previousNode = this.findPreviousElementForCursor(range.commonAncestorContainer.parentElement);
                detach(range.commonAncestorContainer.parentElement);
            }
            else {
                previousNode = this.findPreviousElementForCursor(range.commonAncestorContainer);
                detach(range.commonAncestorContainer);
            }
            e.event.preventDefault();
            // Handle cursor positioning for safari
            this.handleCursorPositioningAfterListRemoval(previousNode);
            parentList = (range.startContainer.nodeName === '#text') ? range.startContainer.parentElement.closest('li') : range.startContainer.closest('li');
        }
        let previousNode;
        if ((!isNOU(endParentList) && range.commonAncestorContainer === this.parent.editableElement) || (!isNOU(parentList) && (!range.collapsed || (parentList.textContent.trim() === '' && isNOU(parentList.previousElementSibling) && isNOU(parentList.nextElementSibling))) && parentList.textContent === fullContent)) {
            range.deleteContents();
            const listItems = this.parent.editableElement.querySelectorAll('li');
            for (let i = 0; i < listItems.length; i++) {
                if (!isNOU(listItems[i].childNodes)) {
                    listItems[i].childNodes.forEach((child) => {
                        if (child.nodeName === 'A' && child.textContent === '') {
                            listItems[i].removeChild(child);
                        }
                    });
                }
                if ((!listItems[i].firstChild || listItems[i].textContent.trim() === '' && !this.hasMediaElement(listItems[i])) && (listItems[i] === startNode || listItems[i] === endNode || listItems[i] === endParentList)) {
                    previousNode = this.findPreviousElementForCursor(listItems[i]);
                    listItems[i].parentNode.removeChild(listItems[i]);
                }
            }
            this.parent.editableElement.querySelectorAll('ol').forEach((ol) => {
                if (!ol.firstChild || ol.textContent.trim() === '' && !this.hasMediaElement(ol)) {
                    previousNode = this.findPreviousElementForCursor(ol);
                    ol.parentNode.removeChild(ol);
                }
            });
            this.parent.editableElement.querySelectorAll('ul').forEach((ul) => {
                if (!ul.firstChild || ul.textContent.trim() === '' && !this.hasMediaElement(ul)) {
                    previousNode = this.findPreviousElementForCursor(ul);
                    ul.parentNode.removeChild(ul);
                }
            });
            e.event.preventDefault();
            // Handle cursor positioning for safari
            this.handleCursorPositioningAfterListRemoval(previousNode);
        }
    }
    onKeyUp(e) {
        if (!isNOU(this.commonLIParent) && !isNOU(this.commonLIParent.querySelector('.removeList'))) {
            const currentLIElem = this.commonLIParent.querySelector('.removeList');
            while (!isNOU(currentLIElem.firstChild)) {
                this.parent.domNode.insertAfter(currentLIElem.firstChild, currentLIElem);
            }
            detach(currentLIElem);
        }
        if (e.event.keyCode === 13) {
            const listElements = this.parent.editableElement.querySelectorAll('UL, OL');
            for (let i = 0; i < listElements.length; i++) {
                if (!isNullOrUndefined(listElements[i]) && !isNOU(listElements[i].parentElement) && !isNullOrUndefined(listElements[i].previousElementSibling) && (listElements[i].parentElement.nodeName === 'UL' || listElements[i].parentElement.nodeName === 'OL')) {
                    listElements[i].previousElementSibling.appendChild(listElements[i]);
                }
            }
        }
    }
    isAtListStart(startNode, range) {
        if (startNode.nodeName !== 'LI') {
            return false;
        }
        const listItem = startNode;
        const firstTextNode = this.getFirstTextNode(listItem);
        return firstTextNode === range.startContainer && range.startOffset === 0;
    }
    getFirstTextNode(element) {
        if (element.nodeType === Node.TEXT_NODE) {
            return element;
        }
        if (element.nodeName === 'BR') {
            return element.parentElement;
        }
        for (let i = 0; i < element.childNodes.length; i++) {
            const firstTextNode = this.getFirstTextNode(element.childNodes[i]);
            if (firstTextNode) {
                return firstTextNode;
            }
        }
        return null;
    }
    keyDownHandler(e) {
        if (e.event.which === 13) {
            this.enterList(e);
        }
        if (e.event.which === 32) {
            this.spaceList(e);
        }
        if (e.event.which === 8) {
            this.backspaceList(e);
        }
        if ((e.event.which === 46 && e.event.action === 'delete')) {
            const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            const commonAncestor = range.commonAncestorContainer;
            const startEle = range.startContainer;
            const endEle = range.endContainer;
            const startNode = startEle.nodeType === 3 ? this.domNode.blockParentNode(startEle) : startEle;
            const endNode = endEle.nodeType === 3 ? this.domNode.blockParentNode(endEle) : endEle;
            if ((commonAncestor.nodeName === 'UL' || commonAncestor.nodeName === 'OL') && startNode !== endNode
                && (!isNullOrUndefined(closest(startNode, 'ul')) || !isNullOrUndefined(closest(startNode, 'ol')))
                && (!isNullOrUndefined(closest(endNode, 'ul')) || !isNullOrUndefined(closest(endNode, 'ol')))
                && ((commonAncestor.lastElementChild === closest(endNode, 'li') && commonAncestor.lastChild !== endNode)) && !range.collapsed) {
                if (this.areAllListItemsSelected(commonAncestor, range)) {
                    detach(commonAncestor);
                }
            }
            this.removeList(range, e);
        }
        if (e.event.which === 9) {
            const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            if (!(e.event.action && e.event.action === 'indent')) {
                this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            }
            if (e.enableTabKey) {
                this.handleListIndentation(e);
            }
            let blockNodes;
            const startNode = this.parent.domNode.getSelectedNode(range.startContainer, range.startOffset);
            const endNode = this.parent.domNode.getSelectedNode(range.endContainer, range.endOffset);
            if ((startNode === endNode && (startNode.nodeName === 'BR' || startNode.nodeName === '#text') &&
                CONSTANT.IGNORE_BLOCK_TAGS.indexOf(startNode.parentNode.tagName.toLocaleLowerCase()) >= 0)) {
                return;
            }
            else {
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    this.domNode.setMarker(this.saveSelection);
                }
                blockNodes = this.domNode.blockNodes();
            }
            const nodes = [];
            let isNested = true;
            for (let i = 0; i < blockNodes.length; i++) {
                if (blockNodes[i].parentNode.tagName === 'LI') {
                    nodes.push(blockNodes[i].parentNode);
                }
                else if (!closest(blockNodes[i], 'OL') && !closest(blockNodes[i], 'UL') && closest(blockNodes[i], 'LI')) {
                    nodes.push(closest(blockNodes[i], 'LI'));
                }
                else if (blockNodes[i].tagName === 'LI' && blockNodes[i].childNodes[0].tagName !== 'P' &&
                    (blockNodes[i].childNodes[0].tagName !== 'OL' &&
                        blockNodes[i].childNodes[0].tagName !== 'UL')) {
                    nodes.push(blockNodes[i]);
                }
            }
            if (nodes.length > 1 || nodes.length === 1) {
                e.event.preventDefault();
                e.event.stopPropagation();
                this.currentAction = this.getAction(nodes[0]);
                if (e.event.shiftKey && (!e.enableTabKey || (e.enableTabKey && !this.listTabIndentation))) {
                    this.revertList(nodes, e);
                    this.revertClean();
                }
                else if (!e.enableTabKey || (e.enableTabKey && !this.listTabIndentation)) {
                    if (this.indentTab(e)) {
                        isNested = this.nestedList(nodes);
                    }
                }
                if (isNested) {
                    this.cleanNode();
                    this.parent.editableElement.focus({ preventScroll: true });
                }
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                    this.saveSelection.restore();
                    if (e.callBack) {
                        e.callBack({
                            requestType: this.currentAction,
                            editorMode: 'HTML',
                            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                            elements: this.parent.domNode.blockNodes(),
                            event: e.event
                        });
                    }
                }
            }
            else {
                if (!(e.event.action && (e.event.action === 'indent')) && !this.listTabIndentation) {
                    if (e.event && e.event.shiftKey && e.event.key === 'Tab') {
                        e.event.action = 'tab';
                    }
                    this.saveSelection = this.domNode.saveMarker(this.saveSelection);
                    this.saveSelection.restore();
                }
            }
            this.listTabIndentation = false;
        }
        else {
            switch (e.event.action) {
                case 'ordered-list':
                    this.applyListsHandler({ subCommand: 'OL', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
                case 'unordered-list':
                    this.applyListsHandler({ subCommand: 'UL', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
                case 'checklist':
                    this.applyListsHandler({ subCommand: 'Checklist', callBack: e.callBack });
                    e.event.preventDefault();
                    break;
            }
        }
    }
    handleListIndentation(e) {
        const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const parentNodeList = this.saveSelection.getParentNodeCollection(range);
        if (!this.indentTab(e)) {
            return;
        }
        if ((parentNodeList[0].nodeName === 'LI' || closest(parentNodeList[0], 'li'))
            && !this.isCursorAtStartOfLI(range)) {
            const startParentNode = parentNodeList[parentNodeList.length - 1];
            const endParentNode = parentNodeList[0];
            const startElementTextNode = range.startContainer;
            if (startParentNode && endParentNode) {
                range.deleteContents();
                if (startParentNode !== endParentNode) {
                    let currentBlockNode = startElementTextNode;
                    while (currentBlockNode.parentElement) {
                        if (this.parent.domNode.isBlockNode(currentBlockNode.parentElement)) {
                            currentBlockNode = currentBlockNode.parentElement;
                            break;
                        }
                        currentBlockNode = currentBlockNode.parentElement;
                    }
                    let cursorPosition;
                    const tabSpaceHTML = '&nbsp;&nbsp;&nbsp;&nbsp;<span class="rte-tab-space"></span>';
                    if (this.parent.domNode.isBlockNode(startParentNode.lastChild)) {
                        startElementTextNode.nodeValue += '\u00A0\u00A0\u00A0\u00A0';
                        cursorPosition = startElementTextNode.nodeValue.length;
                    }
                    else {
                        startParentNode.innerHTML += tabSpaceHTML;
                    }
                    const listItemFirstChild = endParentNode.firstChild;
                    if (listItemFirstChild && this.parent.domNode.isBlockNode(listItemFirstChild)) {
                        while (listItemFirstChild.firstChild) {
                            currentBlockNode.appendChild(listItemFirstChild.firstChild);
                        }
                        listItemFirstChild.remove();
                    }
                    while (endParentNode.firstChild) {
                        if (this.parent.domNode.isBlockNode(endParentNode.firstChild)) {
                            this.parent.domNode.insertAfter(endParentNode.firstChild, currentBlockNode);
                        }
                        else {
                            startParentNode.appendChild(endParentNode.firstChild);
                        }
                    }
                    endParentNode.remove();
                    const tabSpanElement = startParentNode.querySelector('.rte-tab-space');
                    if (tabSpanElement && tabSpanElement.previousSibling) {
                        this.saveSelection.setCursorPoint(this.parent.currentDocument, tabSpanElement.previousSibling, tabSpanElement.previousSibling.textContent.length);
                        tabSpanElement.parentNode.removeChild(tabSpanElement);
                    }
                    else {
                        this.saveSelection.setCursorPoint(this.parent.currentDocument, startElementTextNode, cursorPosition);
                    }
                }
                else {
                    InsertHtml.Insert(this.parent.currentDocument, '&nbsp;&nbsp;&nbsp;&nbsp;', this.parent.editableElement);
                }
                this.listTabIndentation = true;
            }
        }
    }
    /**
     * Checks if inserting a tab would exceed the maxLength constraint.
     *
     * @param {IHtmlKeyboardEvent} e - The keyboard event containing the maxLength constraint
     * @returns {boolean} True if allowed, false if it would exceed maxLength.
     */
    indentTab(e) {
        const tabSpaceLength = 4;
        const maxLength = (typeof e.maxLength === 'number') ? e.maxLength : -1;
        const currentLength = this.parent.editableElement.textContent
            .replace(/(\r\n|\n|\r|\t)/gm, '')
            .replace(/\u200B/g, '').length;
        const selectionLength = this.parent.currentDocument.getSelection().toString().length;
        return maxLength === -1 || (currentLength - selectionLength + tabSpaceLength) <= maxLength;
    }
    isCursorAtStartOfLI(range) {
        let node = range.startContainer;
        while (node && node.nodeName !== 'LI') {
            node = node.parentNode;
        }
        if (!node) {
            return false;
        }
        const tempRange = range.cloneRange();
        tempRange.selectNodeContents(node);
        tempRange.setEnd(range.startContainer, range.startOffset);
        return tempRange.toString().trim() === '';
    }
    spaceKeyAction(e) {
        if (e.event.which === 32) {
            this.spaceList(e);
        }
    }
    getAction(element) {
        const parentNode = element.parentNode;
        return (parentNode.nodeName === 'OL' ? 'OL' : 'UL');
    }
    revertClean() {
        const collectionNodes = this.parent.editableElement.querySelectorAll('ul, ol');
        for (let i = 0; i < collectionNodes.length; i++) {
            const listNodes = collectionNodes[i].querySelectorAll('ul, ol');
            if (listNodes.length > 0) {
                for (let j = 0; j < listNodes.length; j++) {
                    const prevSibling = listNodes[j].previousSibling;
                    if (prevSibling && prevSibling.tagName === 'LI') {
                        prevSibling.appendChild(listNodes[j]);
                    }
                }
            }
        }
    }
    noPreviousElement(elements) {
        let firstNode;
        let firstNodeOL;
        const siblingListOL = elements.querySelectorAll('ol, ul');
        const siblingListLI = elements
            .querySelectorAll('li');
        const siblingListLIFirst = this.domNode.contents(siblingListLI[0])[0];
        if (siblingListLI.length > 0 && (siblingListOL.length <= 1 || siblingListOL[0].childNodes.length > 1) && (siblingListLIFirst.nodeName === 'OL' || siblingListLIFirst.nodeName === 'UL')) {
            firstNode = siblingListLI[0];
        }
        else {
            firstNodeOL = siblingListOL[0];
        }
        if (firstNode) {
            for (let h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h); null) {
                const nextSibling = h.nextSibling;
                prepend([h], firstNode);
                setStyleAttribute(elements, { 'list-style-type': 'none' });
                const listHasCheckListClass = elements.parentNode && elements.parentNode.classList.contains('e-rte-checklist');
                if (listHasCheckListClass) {
                    addClass([elements], ['e-rte-checklist-hidden']);
                }
                setStyleAttribute(firstNode, { 'list-style-type': '' });
                h = nextSibling;
            }
        }
        else if (firstNodeOL) {
            const nestedElement = createElement('li');
            prepend([nestedElement], firstNodeOL);
            for (let h = this.domNode.contents(elements)[0]; h && !this.domNode.isList(h); null) {
                const nextSibling = h.nextSibling;
                nestedElement.appendChild(h);
                h = nextSibling;
            }
            const listHasCheckListClass = elements.parentNode && elements.parentNode.classList.contains('e-rte-checklist');
            prepend([firstNodeOL], elements.parentNode);
            detach(elements);
            const nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
            if (listHasCheckListClass) {
                addClass([nestedElementLI], ['e-rte-checklist-hidden']);
            }
            prepend([nestedElementLI], firstNodeOL.parentNode);
            append([firstNodeOL], nestedElementLI);
        }
        else {
            const nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
            prepend([nestedElementLI], elements.parentNode);
            const nestedElement = createElement(elements.parentNode.tagName);
            if (elements.parentNode.classList.contains('e-rte-checklist')) {
                addClass([nestedElement], ['e-rte-checklist']);
                addClass([nestedElementLI], ['e-rte-checklist-hidden']);
            }
            prepend([nestedElement], nestedElementLI);
            append([elements], nestedElement);
        }
    }
    nestedList(elements) {
        let isNested = false;
        for (let i = 0; i < elements.length; i++) {
            const prevSibling = this.domNode.getPreviousNode(elements[i]);
            if (prevSibling) {
                isNested = true;
                let firstNode;
                let firstNodeLI;
                const siblingListOL = elements[i].querySelectorAll('ol, ul');
                const siblingListLI = elements[i]
                    .querySelectorAll('li');
                const siblingListLIFirst = this.domNode.contents(siblingListLI[0])[0];
                if (siblingListLI.length > 0 && (siblingListOL.length <= 1 || siblingListOL[0].childNodes.length > 1) && (siblingListLIFirst.nodeName === 'OL' || siblingListLIFirst.nodeName === 'UL')) {
                    firstNodeLI = siblingListLI[0];
                }
                else {
                    firstNode = siblingListOL[0];
                }
                if (firstNode) {
                    const nestedElement = createElement('li');
                    prepend([nestedElement], firstNode);
                    for (let h = this.domNode.contents(elements[i])[0]; h && !this.domNode.isList(h); null) {
                        const nextSibling = h.nextSibling;
                        nestedElement.appendChild(h);
                        h = nextSibling;
                    }
                    if (prevSibling.parentNode && prevSibling.parentNode.classList.contains('e-rte-checklist')) {
                        addClass([firstNode], ['e-rte-checklist']);
                    }
                    append([firstNode], prevSibling);
                    detach(elements[i]);
                }
                else if (firstNodeLI) {
                    if (prevSibling.tagName === 'LI') {
                        for (let h = this.domNode.contents(elements[i])[0]; h && !this.domNode.isList(h); null) {
                            const nextSibling = h.nextSibling;
                            prepend([h], firstNodeLI);
                            setStyleAttribute(elements[i], { 'list-style-type': 'none' });
                            setStyleAttribute(firstNodeLI, { 'list-style-type': '' });
                            h = nextSibling;
                        }
                        append([firstNodeLI.parentNode], prevSibling);
                        detach(elements[i]);
                    }
                }
                else {
                    if (prevSibling.tagName === 'LI') {
                        const nestedElement = createElement(elements[i].parentNode.tagName);
                        if (elements[i].parentNode.classList.contains('e-rte-checklist')) {
                            addClass([nestedElement], ['e-rte-checklist']);
                        }
                        nestedElement.style.listStyleType =
                            elements[i].parentNode.style.listStyleType;
                        // Compare inline styles of prevSibling with computed styles of current element
                        const prevInlineStyle = prevSibling.getAttribute('style');
                        const computedStyles = getComputedStyle(elements[i]);
                        const currentInlineStyle = elements[i].style;
                        if (prevInlineStyle) {
                            const stylePairs = prevInlineStyle.split(';').filter(Boolean);
                            stylePairs.forEach((style) => {
                                const [prop, value] = style.split(':').map((s) => s.trim());
                                if (prop && value && prop !== 'list-style-type') {
                                    const computedValue = computedStyles.getPropertyValue(prop).trim();
                                    const currentInlineValue = currentInlineStyle.getPropertyValue(prop).trim();
                                    if (computedValue !== value && !currentInlineValue) {
                                        // Set the inline style to match the computed style
                                        elements[i].style.setProperty(prop, computedValue);
                                    }
                                }
                            });
                        }
                        append([nestedElement], prevSibling);
                        append([elements[i]], nestedElement);
                    }
                    else if (prevSibling.tagName === 'OL' || prevSibling.tagName === 'UL') {
                        append([elements[i]], prevSibling);
                    }
                }
            }
            else {
                const element = elements[i];
                isNested = true;
                this.noPreviousElement(element);
            }
        }
        return isNested;
    }
    isCursorBeforeTable(range) {
        return range.startOffset === range.endOffset &&
            range.startContainer.childNodes.length > 0 && !isNOU(range.startContainer.childNodes[range.startOffset]) &&
            range.startContainer.childNodes[range.startOffset].nodeName === 'TABLE';
    }
    isCursorAtEndOfTable(range) {
        return (range.startOffset === range.endOffset &&
            range.startContainer.childNodes.length > 0 && !isNOU(range.startContainer.childNodes[range.startOffset - 1]) &&
            range.startContainer.childNodes[range.startOffset - 1].nodeName === 'TABLE');
    }
    isListItemWithTableChild(node) {
        return node.nodeName === 'LI' && !isNOU(node.firstChild) &&
            node.firstChild.nodeName === 'TABLE';
    }
    handleChecklistToggle(e) {
        const target = e.event.target;
        if (target.tagName === 'LI' || !isNullOrUndefined(closest(target, '.' + 'e-rte-checklist'))) {
            e.event.preventDefault();
            e.event.stopPropagation();
            if (target.classList.contains('e-rte-checklist-checked')) {
                target.classList.remove('e-rte-checklist-checked');
            }
            else {
                target.classList.add('e-rte-checklist-checked');
            }
        }
    }
    isCaretImmediatelyBeforeTable(range) {
        let cursorBeforeTable = false;
        let table = null;
        const isBeforeFirstTable = range.collapsed && range.startContainer === range.endContainer &&
            range.startOffset === range.endOffset &&
            range.startContainer.nodeType === Node.ELEMENT_NODE &&
            range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset].nodeName === 'TABLE';
        if (isBeforeFirstTable) {
            table = range.startContainer.childNodes[range.startOffset];
            const newRange = this.parent.editableElement.ownerDocument.createRange();
            newRange.setStartBefore(table);
            newRange.setEndBefore(table);
            cursorBeforeTable = range.startContainer === newRange.startContainer &&
                range.endContainer === newRange.endContainer &&
                range.startOffset === newRange.startOffset &&
                range.endOffset === newRange.endOffset;
        }
        if (cursorBeforeTable && !isNOU(table)) {
            table.classList.add('temp-cursor-table');
            return true;
        }
        return false;
    }
    applyListsHandler(e, isCheckedCheckList) {
        let range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const isRangeBeforeTable = this.isCaretImmediatelyBeforeTable(range);
        const checkListToggleAction = e.subCommand === 'Checklist' && e.item && e.item.action === 'toggleChecklist';
        if (checkListToggleAction) {
            this.handleChecklistToggle(e);
        }
        else {
            const selectedNode = (range.startContainer.nodeName === 'HR' ? range.startContainer : range.startContainer.childNodes[range.startOffset]);
            const lastSelectedNode = (selectedNode ? (selectedNode.nodeName === 'HR' ? selectedNode.nextElementSibling : null) : null);
            const checkCursorPointer = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (Browser.userAgent.indexOf('Firefox') !== -1 && range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement) {
                const startChildNodes = range.startContainer.childNodes;
                const startNode = ((startChildNodes[(range.startOffset > 0) ? (range.startOffset - 1) :
                    range.startOffset]) || range.startContainer);
                const endNode = (range.endContainer.childNodes[(range.endOffset > 0) ? (range.endOffset - 1) :
                    range.endOffset] || range.endContainer);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let lastSelectionNode = endNode.lastChild.nodeName === 'BR' ? (isNOU(endNode.lastChild.previousSibling) ? endNode
                    : endNode.lastChild.previousSibling) : endNode.lastChild;
                while (!isNOU(lastSelectionNode) && lastSelectionNode.nodeName !== '#text' && lastSelectionNode.nodeName !== 'IMG' &&
                    lastSelectionNode.nodeName !== 'BR' && lastSelectionNode.nodeName !== 'HR') {
                    lastSelectionNode = lastSelectionNode.lastChild;
                }
                this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startNode, lastSelectionNode, 0, lastSelectionNode.textContent.length);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            }
            if (range.startContainer === range.endContainer && range.startContainer === this.parent.editableElement &&
                range.startOffset === range.endOffset && range.startOffset === 0 &&
                this.parent.editableElement.textContent.length === 0 && (this.parent.editableElement.childNodes[0].nodeName !== 'TABLE' &&
                this.parent.editableElement.childNodes[0].nodeName !== 'IMG')) {
                const focusNode = range.startContainer.childNodes[0];
                this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, focusNode, focusNode, 0, 0);
                range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            }
            this.saveSelection = this.parent.nodeSelection.save(range, this.parent.currentDocument);
            this.currentAction = e.subCommand;
            this.currentAction = e.subCommand = this.currentAction === 'NumberFormatList' ? 'OL' : this.currentAction === 'BulletFormatList' ? 'UL' : this.currentAction;
            this.domNode.setMarker(this.saveSelection);
            let listsNodes = this.domNode.blockNodes(true);
            if (e.enterAction === 'BR') {
                if (this.isCursorBeforeTable(range)) {
                    listsNodes = [range.startContainer.childNodes[range.startOffset]];
                }
                else if (this.isCursorAtEndOfTable(range)) {
                    listsNodes = [range.startContainer.childNodes[range.startOffset - 1]];
                }
                else if (listsNodes.length === 1 && this.isListItemWithTableChild(listsNodes[0])) {
                    listsNodes[0] = listsNodes[0].firstChild;
                }
                else {
                    this.setSelectionBRConfig();
                    this.parent.domNode.convertToBlockNodes(this.parent.domNode.blockNodes(), true);
                    this.setSelectionBRConfig();
                    listsNodes = this.parent.domNode.blockNodes();
                }
            }
            for (let i = 0; i < listsNodes.length; i++) {
                if (listsNodes[i].tagName === 'TABLE' && !range.collapsed) {
                    listsNodes.splice(i, 1);
                }
                if (listsNodes.length > 0 && listsNodes[i].tagName !== 'LI'
                    && 'LI' === listsNodes[i].parentNode.tagName) {
                    listsNodes[i] = listsNodes[i].parentNode;
                }
            }
            this.applyLists(listsNodes, this.currentAction, e.selector, e.item, e, checkCursorPointer, isCheckedCheckList);
            if (lastSelectedNode && range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
                this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, lastSelectedNode, 0);
            }
            if (isRangeBeforeTable) {
                const table = this.parent.editableElement.ownerDocument.querySelector('.temp-cursor-table');
                if (!isNullOrUndefined(table)) {
                    const newRange = this.parent.editableElement.ownerDocument.createRange();
                    newRange.setStartBefore(table);
                    newRange.setEndBefore(table);
                    this.parent.nodeSelection.setRange(this.parent.currentDocument, newRange);
                    removeClass([table], ['temp-cursor-table']);
                }
            }
        }
        if (e.callBack) {
            e.callBack({
                requestType: this.currentAction,
                event: e.event,
                editorMode: 'HTML',
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.domNode.blockNodes()
            });
        }
    }
    setSelectionBRConfig() {
        const startElem = this.parent.editableElement.querySelector('.' + markerClassName.startSelection);
        const endElem = this.parent.editableElement.querySelector('.' + markerClassName.endSelection);
        if (isNOU(endElem)) {
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, startElem, 0);
        }
        else {
            this.parent.nodeSelection.setSelectionText(this.parent.currentDocument, startElem, endElem, 0, 0);
        }
    }
    // This method identifies unique list items and their top-level UL/OL parents from a given set of elements, returning both in separate arrays.
    commonRevertList(elements) {
        const commonList = [];
        const commonListParent = [];
        let commonElement;
        for (let i = 0; i < elements.length; i++) {
            let commonParentULorOL = elements[i].parentElement;
            while (this.isListTag(commonParentULorOL.parentElement.nodeName)) {
                commonParentULorOL = commonParentULorOL.parentElement;
            }
            if (i === 0) {
                commonList.push(elements[i]);
                commonElement = commonParentULorOL;
                commonListParent.push(commonElement);
                continue;
            }
            if (commonParentULorOL !== commonElement) {
                commonList.push(elements[i]);
                commonElement = commonParentULorOL;
                commonListParent.push(commonElement);
            }
        }
        return { commonList, commonListParent };
    }
    applyLists(elements, type, selector, item, e, checkCursorPointer, isCheckedCheckList) {
        let isReverse = true;
        const currentRange = this.parent.nodeSelection.getRange(this.parent.currentDocument);
        const isCusrsoratTableEnd = this.parent.nodeSelection.processedTableImageCursor(currentRange).endName === 'TABLE';
        if (type === 'Checklist') {
            type = 'UL';
        }
        if (this.isRevert(elements, type, item, e.subCommand) && isNOU(item)) {
            const revertListELements = this.commonRevertList(elements);
            this.completeRevertList(revertListELements, e.enterAction);
        }
        else {
            this.checkLists(elements, type, item, checkCursorPointer, e.subCommand, isCheckedCheckList);
            const targetEl = elements[0];
            const marginLeftAttribute = [];
            if (targetEl.style.marginLeft !== '') {
                marginLeftAttribute.push({ 'margin-left': targetEl.style.marginLeft });
            }
            const listStyles = [];
            for (let i = 0; i < elements.length; i++) {
                if (!isNOU(item) && !isNOU(item.listStyle) && e.subCommand !== 'Checklist') {
                    if (item.listStyle === 'listImage') {
                        listStyles.push({ 'list-style-image': item.listImage });
                    }
                    else {
                        const formattedStyle = this.formatListStyle(item.listStyle);
                        listStyles.push({
                            'list-style-image': 'none',
                            'list-style-type': formattedStyle
                        });
                    }
                }
                elements[i].style.removeProperty('margin-left');
                const elemAtt = elements[i].tagName === 'IMG' || elements[i].classList.contains('e-editor-select-start') || elements[i].tagName === 'TABLE' ? {} : this.extractAllAttributes(elements[i]);
                if (elements[i].getAttribute('contenteditable') === 'true'
                    && elements[i].childNodes.length === 1 && elements[i].childNodes[0].nodeName === 'TABLE') {
                    const listEle = document.createElement(type);
                    listEle.innerHTML = '<li><br/></li>';
                    elements[i].appendChild(listEle);
                }
                else if ('LI' !== elements[i].tagName && isNOU(item) &&
                    elements[i].nodeName === 'BLOCKQUOTE') {
                    isReverse = false;
                    const tempElement = this.parent.editableElement.ownerDocument.createElement('div');
                    const ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, marginLeftAttribute);
                    this.applyListStyles(ul, listStyles);
                    const replaceHTML = elements[i].innerHTML;
                    const li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    ul.appendChild(li);
                    tempElement.appendChild(ul);
                    let collectionString = tempElement.innerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    elements[i].innerHTML = collectionString;
                }
                else if ('LI' !== elements[i].tagName && isNOU(item)) {
                    isReverse = false;
                    // const tempElement: HTMLElement = this.parent.editableElement.ownerDocument.createElement('div');
                    const ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, marginLeftAttribute);
                    this.applyListStyles(ul, listStyles);
                    let replaceHTML;
                    if (elements[i].tagName.toLowerCase() === CONSTANT.DEFAULT_TAG || elements[i].tagName === 'DIV') {
                        replaceHTML = elements[i].innerHTML;
                    }
                    else {
                        replaceHTML = elements[i].outerHTML;
                    }
                    if (elements[i].tagName === 'HR' &&
                        elements[i].firstElementChild &&
                        elements[i].firstElementChild.tagName === 'SPAN' &&
                        elements[i].firstElementChild.hasAttribute('class') &&
                        elements[i].firstElementChild.className === 'e-editor-select-start') {
                        replaceHTML = elements[i].firstElementChild.outerHTML + elements[i].outerHTML;
                    }
                    const li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    let innerHTML = li.outerHTML;
                    innerHTML = this.setStyle(innerHTML);
                    ul.innerHTML = innerHTML;
                    let collectionString = ul.outerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    this.domNode.replaceWith(elements[i], collectionString);
                }
                else if (!isNOU(item) && 'LI' !== elements[i].tagName) {
                    // eslint-disable-next-line
                    isReverse = false;
                    const tempElement = this.parent.editableElement.ownerDocument.createElement('div');
                    const ul = this.parent.editableElement.ownerDocument.createElement(type);
                    this.applyListStyles(ul, listStyles);
                    tempElement.appendChild(ul);
                    let replaceHTML;
                    if (elements[i].tagName.toLowerCase() === CONSTANT.DEFAULT_TAG || elements[i].tagName === 'DIV') {
                        replaceHTML = elements[i].innerHTML;
                    }
                    else {
                        replaceHTML = elements[i].outerHTML;
                    }
                    const li = this.parent.editableElement.ownerDocument.createElement('li');
                    this.applyAllAttributes(li, elemAtt);
                    if (isCheckedCheckList) {
                        li.classList.add('e-rte-checklist-checked');
                    }
                    li.innerHTML = replaceHTML;
                    const innerHTML = li.outerHTML;
                    ul.innerHTML = innerHTML;
                    let collectionString = tempElement.innerHTML;
                    if (e.subCommand === 'Checklist') {
                        collectionString = this.addCheckListClass(collectionString);
                    }
                    this.domNode.replaceWith(elements[i], collectionString);
                }
            }
        }
        this.cleanNode();
        if (e.enterAction === 'BR') {
            const spansToRemove = document.querySelectorAll('span#removeSpan');
            spansToRemove.forEach((span) => {
                const fragment = document.createDocumentFragment();
                while (span.firstChild) {
                    fragment.appendChild(span.firstChild);
                }
                span.parentNode.replaceChild(fragment, span);
            });
        }
        this.parent.editableElement.focus({ preventScroll: true });
        if (isIDevice()) {
            setEditFrameFocus(this.parent.editableElement, selector);
        }
        this.saveSelection = this.domNode.saveMarker(this.saveSelection);
        if (!isCusrsoratTableEnd) {
            this.saveSelection.restore();
        }
        else {
            const tables = Array.from(this.parent.editableElement.querySelectorAll('table'));
            if (tables.length > 0 && elements && elements.length > 0) {
                for (const table of tables) {
                    const next = table.nextElementSibling;
                    if (next && next.textContent && elements[0].textContent &&
                        table.nextElementSibling.textContent === elements[0].textContent) {
                        this.saveSelection.setCursorPoint(this.parent.currentDocument, next, 0);
                        break; // stop after placing once
                    }
                }
            }
        }
    }
    extractAllAttributes(element) {
        const attributes = {};
        if (element && element.attributes) {
            Array.from(element.attributes).forEach((attr) => {
                attributes[attr.name] = attr.value;
            });
        }
        return attributes;
    }
    applyAllAttributes(element, attributes) {
        Object.keys(attributes).forEach((key) => {
            element.setAttribute(key, attributes[key]);
        });
    }
    applyListStyles(element, listStyles) {
        for (let i = 0; i < listStyles.length; i++) {
            const styleObj = listStyles[i];
            for (const key in styleObj) {
                if (Object.prototype.hasOwnProperty.call(styleObj, key)) {
                    element.style.setProperty(key, styleObj[key]);
                }
            }
        }
    }
    addCheckListClass(collectionString) {
        const divElement = createElement('div');
        divElement.innerHTML = collectionString;
        const checkLists = divElement.firstElementChild;
        this.applyCheckListClasses(checkLists);
        return divElement.innerHTML;
    }
    applyCheckListClasses(element) {
        addClass([element], 'e-rte-checklist');
    }
    setStyle(innerHTML) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = innerHTML;
        const liElement = tempDiv.querySelector('li');
        if (!liElement) {
            return innerHTML;
        }
        const targetProps = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
        let styleTextMap = new Map(); // Map<styleProp, Map<styleValue, text>>
        const walker = this.parent.currentDocument.createTreeWalker(liElement, NodeFilter.SHOW_TEXT, null);
        let node = walker.nextNode();
        while (node) {
            const text = node.textContent || '';
            const current = node.parentElement;
            const styleSnapshot = this.getStyleSnapshot(current, liElement, targetProps);
            // Merge text into styleTextMap
            styleTextMap = this.setStyleTextMap(styleSnapshot, styleTextMap, text);
            node = walker.nextNode();
        }
        if (styleTextMap.size === 0 && liElement.childNodes.length === 1 && liElement.textContent === '') {
            // When there is no text content inside li element
            let innerMostInline;
            if (liElement.querySelector('.e-editor-select-start')) {
                innerMostInline = liElement.querySelector('.e-editor-select-start').parentElement;
            }
            if (!isNOU(innerMostInline) && innerMostInline.childNodes.length === 2 && innerMostInline.querySelector('br')) {
                while (innerMostInline !== liElement) {
                    const text = '';
                    const styleSnapshot = this.getStyleSnapshot(innerMostInline, liElement, targetProps);
                    styleTextMap = this.setStyleTextMap(styleSnapshot, styleTextMap, text);
                    innerMostInline = innerMostInline.parentElement;
                }
            }
        }
        // Apply styles where the accumulated text matches li's full text
        styleTextMap.forEach((valueMap, prop) => {
            valueMap.forEach((text, styleValue) => {
                if (text === liElement.textContent) {
                    liElement.style.setProperty(prop, styleValue);
                }
            });
        });
        return tempDiv.innerHTML;
    }
    setStyleTextMap(styleSnapshot, styleTextMap, text) {
        styleSnapshot.forEach((value, prop) => {
            if (!styleTextMap.has(prop)) {
                styleTextMap.set(prop, new Map());
            }
            const valueMap = styleTextMap.get(prop) || new Map();
            const existingText = valueMap.get(value) || '';
            valueMap.set(value, existingText + text);
        });
        return styleTextMap;
    }
    getStyleSnapshot(current, liElement, targetProps) {
        const styleSnapshot = new Map();
        // Traverse up to <li> and collect inline styles and semantic tags
        while (current && current !== liElement) {
            targetProps.forEach((prop) => {
                const inlineValue = current.style.getPropertyValue(prop);
                if (inlineValue && !styleSnapshot.has(prop)) {
                    styleSnapshot.set(prop, inlineValue);
                }
            });
            if ((current.tagName === 'B' || current.tagName === 'STRONG') && !styleSnapshot.has('font-weight')) {
                styleSnapshot.set('font-weight', 'bold');
            }
            if ((current.tagName === 'I' || current.tagName === 'EM') && !styleSnapshot.has('font-style')) {
                styleSnapshot.set('font-style', 'italic');
            }
            current = current.parentElement;
        }
        return styleSnapshot;
    }
    isRevert(nodes, tagName, item, subCommand) {
        let isRevert = true;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].tagName !== 'LI') {
                return false;
            }
            if (nodes[i].parentNode.tagName !== tagName ||
                isNOU(item) && nodes[i].parentNode.style.listStyleType !== '' ||
                (nodes[i].parentNode.tagName === 'UL' && nodes[i].parentNode.classList.contains('e-rte-checklist') && subCommand !== 'Checklist')) {
                isRevert = false;
            }
            if (nodes[i].parentNode.tagName === tagName && nodes[i].parentNode.style.listStyleType !== '') {
                isRevert = true;
            }
            if (nodes[i].parentNode.tagName === 'UL' && !nodes[i].parentNode.classList.contains('e-rte-checklist') && subCommand === 'Checklist') {
                isRevert = false;
            }
        }
        return isRevert;
    }
    checkLists(nodes, tagName, item, checkCursorPointer, subCommand, isCheckedCheckList) {
        const nodesTemp = [];
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i].parentNode;
            if ((nodes[i].tagName === 'LI' && node.tagName !== tagName && nodesTemp.indexOf(node) < 0) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && nodesTemp.indexOf(node) < 0 && item !== null) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && subCommand === 'Checklist' && nodesTemp.indexOf(node) < 0) ||
                (nodes[i].tagName === 'LI' && node.tagName === tagName && subCommand !== 'Checklist' && nodesTemp.indexOf(node) < 0 && node.classList.contains('e-rte-checklist'))) {
                nodesTemp.push(node);
            }
            if (isNOU(item) && (node.tagName === tagName ||
                ((node.tagName === 'UL' || node.tagName === 'OL') && node.hasAttribute('style')))) {
                if (node.hasAttribute('style')) {
                    node.removeAttribute('style');
                }
            }
        }
        this.convertListType(nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand, isCheckedCheckList);
    }
    /*
     * Convert list type based on the different list
     * Transforms selected list items between ordered and unordered lists
     */
    convertListType(nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand, isCheckedCheckList) {
        tagName = subCommand === 'Checklist' ? 'Checklist' : tagName;
        // Add classes to selected LI elements for tracking
        for (let k = 0; k < nodes.length; k++) {
            nodes[k].classList.add('list-temp-element');
            if (isCheckedCheckList) {
                nodes[k].classList.add('e-rte-checklist-checked');
            }
        }
        // First call with reverse order because when elements are changed in the DOM during nested list usecase,
        // the DOM element has already changed and we can no longer get that element in the collection.
        // So the nested use case is not working. That's why we reverse and convert with the normal order.
        // For the reverse order, most of them are converted however some of that not working because of nested list,
        // so once again call the convert with the normal order - that way it works well.
        const reversedParentLists = Array.from(new Set(nodes.map((node) => node.parentNode)
            .filter((parent) => parent.tagName === 'OL' || parent.tagName === 'UL'))).reverse();
        this.convertListTypeInternal(reversedParentLists, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand);
        // Update nodes reference to point to converted elements in DOM
        nodes = Array.from(this.parent.currentDocument.querySelectorAll('.list-temp-element'));
        // Second call without reverse - process any remaining unconverted elements from first pass
        const naturalOrderParentLists = Array.from(new Set(nodes.map((node) => node.parentNode)
            .filter((parent) => parent.tagName === 'OL' || parent.tagName === 'UL')));
        this.convertListTypeInternal(naturalOrderParentLists, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand);
        // Update nodes reference again after second conversion
        nodes = Array.from(this.parent.currentDocument.querySelectorAll('.list-temp-element'));
        nodes.forEach((el) => {
            el.classList.remove('list-temp-element');
            if (el.classList.length === 0) {
                el.removeAttribute('class');
            }
        });
    }
    convertListTypeInternal(initialNodesTemp, nodes, tagName, nodesTemp, checkCursorPointer, item, subCommand) {
        for (let i = 0; i < initialNodesTemp.length; i++) {
            const list = initialNodesTemp[i];
            if (!checkCursorPointer && (list.tagName === 'UL' || list.tagName === 'OL')) {
                const newFragment = this.parent.currentDocument.createDocumentFragment();
                let currentTagName = list.tagName;
                // Track if current list is a checklist
                let isCurrentChecklist = list.classList.contains('e-rte-checklist');
                // Determine if target is a checklist
                const isTargetChecklist = tagName === 'Checklist';
                let newList = this.parent.currentDocument.createElement(isTargetChecklist ? 'ul' : tagName.toLowerCase());
                // Add class for checklist if target is checklist
                if (isTargetChecklist) {
                    this.applyCheckListClasses(newList);
                }
                const listElements = Array.from(list.children).filter((child) => child.tagName === 'LI');
                listElements.forEach((child) => {
                    if (nodes.indexOf(child) !== -1) {
                        // Check if we're dealing with the same list type
                        if ((currentTagName === (isTargetChecklist ? 'ul' : tagName.toLowerCase())) &&
                            (isCurrentChecklist === isTargetChecklist)) {
                            const clonedChild = child.cloneNode(true);
                            if (!isCurrentChecklist && clonedChild.classList.contains('e-rte-checklist-checked')) {
                                clonedChild.classList.remove('e-rte-checklist-checked');
                            }
                            newList.appendChild(clonedChild);
                        }
                        else {
                            // Create new list for different type
                            const createNodeName = isTargetChecklist ? 'UL' : tagName;
                            newList = this.parent.currentDocument.createElement(createNodeName.toLowerCase());
                            if (currentTagName === tagName && !(list.classList.contains('e-rte-checklist') && tagName === 'UL')) {
                                this.transferAttributes(list, newList);
                            }
                            // Add class for checklist if target is checklist
                            if (isTargetChecklist) {
                                this.applyCheckListClasses(newList);
                            }
                            currentTagName = isTargetChecklist ? 'ul' : tagName.toLowerCase();
                            // Store the current checklist state BEFORE processing child
                            isCurrentChecklist = isTargetChecklist;
                            newFragment.appendChild(newList);
                            const clonedChild = child.cloneNode(true);
                            this.applyListItemStyle(newList, item);
                            if (!isCurrentChecklist && clonedChild.classList.contains('e-rte-checklist-checked')) {
                                clonedChild.classList.remove('e-rte-checklist-checked');
                            }
                            newList.appendChild(clonedChild);
                        }
                    }
                    else {
                        if (currentTagName !== list.tagName.toLowerCase() || isCurrentChecklist !== list.classList.contains('e-rte-checklist')) {
                            currentTagName = list.tagName.toLowerCase();
                            isCurrentChecklist = list.classList.contains('e-rte-checklist');
                            newList = this.parent.currentDocument.createElement(currentTagName);
                            // Add class for checklist if it's a checklist
                            if (isCurrentChecklist) {
                                this.applyCheckListClasses(newList);
                            }
                            this.transferAttributes(list, newList);
                            newFragment.appendChild(newList);
                        }
                        newList.appendChild(child.cloneNode(true));
                    }
                });
                list.parentNode.replaceChild(newFragment, list);
            }
            else if (checkCursorPointer) {
                for (let j = nodesTemp.length - 1; j >= 0; j--) {
                    const h = nodesTemp[j];
                    const createNodeName = tagName === 'Checklist' ? 'ul' : tagName;
                    const replace = '<' + createNodeName.toLowerCase() + ' '
                        + this.domNode.attributes(h) + '>' + h.innerHTML + '</' + createNodeName.toLowerCase() + '>';
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = replace;
                    this.applyListItemStyle(tempDiv.firstChild, item);
                    if (subCommand === 'Checklist') {
                        // Add the check list class to the list so we can convert that list into the check list.
                        tempDiv.innerHTML = this.addCheckListClass(tempDiv.innerHTML);
                    }
                    else {
                        // Revert the check list element when converting to other type of list
                        const listElement = tempDiv.querySelectorAll('li');
                        for (let k = 0; k < listElement.length; k++) {
                            this.revertChecklistItem(listElement[k]);
                        }
                        // If converting a check list to another type of list, remove the check list class from the list.
                        if (tempDiv.firstElementChild && tempDiv.firstElementChild.classList.contains('e-rte-checklist')) {
                            tempDiv.firstElementChild.classList.remove('e-rte-checklist');
                            if (tempDiv.firstElementChild.classList.length === 0) {
                                tempDiv.firstElementChild.removeAttribute('class');
                            }
                        }
                    }
                    this.domNode.replaceWith(nodesTemp[j], tempDiv.innerHTML);
                }
            }
        }
    }
    /*
     * Applies list style to a list item element
     * @param node The list item element to apply styles to
     * @param item The advanced list item configuration
     */
    applyListItemStyle(node, item) {
        if (!isNOU(item) && !isNOU(item.listStyle)) {
            if (item.listStyle === 'listImage') {
                setStyleAttribute(node, { 'list-style-image': item.listImage });
            }
            else {
                setStyleAttribute(node, { 'list-style-image': 'none' });
                const formattedStyle = this.formatListStyle(item.listStyle);
                setStyleAttribute(node, { 'list-style-type': formattedStyle });
            }
        }
    }
    /*
     * Transfers attributes from source element to target element
     */
    transferAttributes(sourceList, targetList) {
        for (let j = 0; j < sourceList.attributes.length; j++) {
            const attr = sourceList.attributes[j];
            targetList.setAttribute(attr.name, attr.value);
        }
    }
    cleanNode() {
        const liParents = this.parent.editableElement.querySelectorAll('ol + ol, ul + ul');
        let listStyleType;
        let firstNodeOL;
        for (let c = 0; c < liParents.length; c++) {
            const node = liParents[c];
            let toFindtopOlUl = true;
            let containsListElements = node;
            while (containsListElements.parentElement) {
                if (containsListElements.parentElement && containsListElements.parentElement.tagName !== 'LI' && containsListElements.parentElement.tagName !== 'OL' && containsListElements.parentElement.tagName !== 'UL') {
                    break;
                }
                containsListElements = containsListElements.parentElement;
            }
            if (toFindtopOlUl && (liParents[c].parentElement.parentElement.nodeName === 'OL' || liParents[c].parentElement.parentElement.nodeName === 'UL')) {
                toFindtopOlUl = false;
                const preElement = liParents[c].parentElement.parentElement;
                listStyleType = preElement.style.listStyleType;
                firstNodeOL = node.previousElementSibling;
            }
            // Check if the current node is part of the same list structure as its previous sibling
            const isSameList = this.domNode.isList(node.previousElementSibling) && node.parentElement === node.previousElementSibling.parentElement && node.parentElement.tagName === 'LI';
            if (this.domNode.isList(node.previousElementSibling) &&
                (this.domNode.openTagString(node) === this.domNode.openTagString(node.previousElementSibling)) || isSameList) {
                const contentNodes = this.domNode.contents(node);
                for (let f = 0; f < contentNodes.length; f++) {
                    node.previousElementSibling.appendChild(contentNodes[f]);
                }
                node.parentNode.removeChild(node);
            }
            else if (!isNOU(node.getAttribute('level'))) {
                if (node.tagName === node.previousElementSibling.tagName) {
                    node.previousElementSibling.lastChild.append(node);
                }
            }
            else if (this.domNode.isList(node.previousElementSibling) && containsListElements.contains(node.previousElementSibling) && ((node.tagName === 'OL' || node.tagName === 'UL') && (node.previousElementSibling.nodeName === 'OL' || node.previousElementSibling.nodeName === 'UL')) &&
                ((node.previousElementSibling.classList.contains('e-rte-checklist') && node.classList.contains('e-rte-checklist')) && !(node.previousElementSibling.classList.contains('e-rte-checklist') && node.classList.contains('e-rte-checklist')))) {
                const contentNodes = this.domNode.contents(node);
                for (let f = 0; f < contentNodes.length; f++) {
                    node.previousElementSibling.appendChild(contentNodes[f]);
                }
                node.parentNode.removeChild(node);
            }
        }
        if (firstNodeOL) {
            firstNodeOL.style.listStyleType = listStyleType;
            const range = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            let listOlUlElements = [];
            if (range.commonAncestorContainer.nodeName === 'UL' || range.commonAncestorContainer.nodeName === 'OL') {
                if (range.commonAncestorContainer instanceof Element) {
                    listOlUlElements.push(range.commonAncestorContainer);
                }
                listOlUlElements = listOlUlElements.concat(Array.from(range.commonAncestorContainer.querySelectorAll('ol, ul')));
            }
            else {
                listOlUlElements = Array.from(range.commonAncestorContainer.querySelectorAll('ol, ul'));
            }
            for (let k = 0; k < listOlUlElements.length; k++) {
                let listStyle;
                let listElements = listOlUlElements[k];
                while (listElements) {
                    if (listElements.nodeName === 'OL' || listElements.nodeName === 'OL') {
                        if (listElements.style.listStyleType !== '' && listElements.style.listStyleType !== 'none' && listElements.nodeName !== 'LI') {
                            listStyle = listElements.style.listStyleType;
                        }
                        else if (!isNOU(listStyle) && (listElements.style.listStyleType === '' || listElements.style.listStyleType === 'none') &&
                            listElements.nodeName !== 'LI' && (listElements.nodeName === 'UL' || listElements.nodeName === 'OL')) {
                            listElements.style.listStyleType = listStyle;
                        }
                    }
                    listElements = listElements.querySelector('UL,OL');
                }
            }
        }
    }
    findUnSelected(temp, elements) {
        temp = temp.slice().reverse();
        if (temp.length > 0) {
            const rightIndent = [];
            const indentElements = [];
            const lastElement = elements[elements.length - 1];
            let lastElementChild = [];
            const childElements = [];
            lastElementChild = (lastElement.childNodes);
            for (let z = 0; z < lastElementChild.length; z++) {
                if (lastElementChild[z].tagName === 'OL' || lastElementChild[z].tagName === 'UL') {
                    const childLI = lastElementChild[z]
                        .querySelectorAll('li');
                    if (childLI.length > 0) {
                        for (let y = 0; y < childLI.length; y++) {
                            childElements.push(childLI[y]);
                        }
                    }
                }
            }
            for (let i = 0; i < childElements.length; i++) {
                let count = 0;
                for (let j = 0; j < temp.length; j++) {
                    if (!childElements[i].contains((temp[j]))) {
                        count = count + 1;
                    }
                }
                if (count === temp.length) {
                    indentElements.push(childElements[i]);
                }
            }
            if (indentElements.length > 0) {
                for (let x = 0; x < indentElements.length; x++) {
                    if (this.domNode.contents(indentElements[x])[0].nodeName !== 'OL' &&
                        this.domNode.contents(indentElements[x])[0].nodeName !== 'UL') {
                        rightIndent.push(indentElements[x]);
                    }
                }
            }
            if (rightIndent.length > 0) {
                this.nestedList(rightIndent);
            }
        }
    }
    revertChecklistItem(li) {
        if (li && li.parentElement && li.parentElement.classList.contains('e-rte-checklist')) {
            li.parentElement.classList.remove('e-rte-checklist');
        }
        if (li && li.classList.contains('e-rte-checklist-checked')) {
            li.classList.remove('e-rte-checklist-checked');
        }
    }
    // This method checks if a given tag name is a list-related element (UL, OL, or LI).
    isListTag(elementName) {
        return elementName === 'OL' || elementName === 'UL' || elementName === 'LI';
    }
    // This method inserts closing tags for all ancestor lists above a selected list item until reaching the specified main list, ensuring proper HTML structure.
    closeAncestorsBeforeSelection(selectionLi, parentOfMainUlorOL) {
        const parentOfSelectionLi = selectionLi.parentElement;
        const insertBeforElement = selectionLi;
        while (this.isListTag(selectionLi.parentElement.nodeName) && selectionLi.parentElement !== parentOfMainUlorOL) {
            parentOfSelectionLi.insertBefore(this.closeTag(selectionLi.parentElement.nodeName), insertBeforElement);
            selectionLi = selectionLi.parentElement;
        }
    }
    // This method inserts closing tags for list elements after the end of a selection, climbing up until the common parent or main list, then reopens the list structure to maintain valid HTML.
    closeAncestorsAfterSelection(endElement, endSelectionLi, startLi, endLi, parentOfMainUlorOL) {
        let endInsertAfterElement = endElement;
        this.domNode.insertAfter(this.closeTag(endSelectionLi.nodeName), endInsertAfterElement);
        endInsertAfterElement = endInsertAfterElement.nextSibling;
        let endSelectionElement = endSelectionLi.parentElement;
        let allClosed = false;
        if (startLi !== endLi) {
            // Close until we reach the common parent with the start LI
            if (endSelectionElement === startLi.parentElement || endSelectionElement === parentOfMainUlorOL) {
                allClosed = true;
            }
            while (!allClosed) {
                this.domNode.insertAfter(this.closeTag(endSelectionElement.nodeName), endInsertAfterElement);
                endInsertAfterElement = endInsertAfterElement.nextSibling;
                endSelectionElement = endSelectionElement.parentElement;
                if (endSelectionElement === startLi.parentElement || endSelectionElement === parentOfMainUlorOL) {
                    allClosed = true;
                }
            }
        }
        this.reopenListStructure(endSelectionLi, endInsertAfterElement, parentOfMainUlorOL);
    }
    // This method inserts opening tags for ancestor lists after a selection to restore the original nested list structure and adjusts classes for proper formatting.
    reopenListStructure(endSelectionLi, endInsertAfterElement, parentOfMainUlorOL) {
        while (this.isListTag(endSelectionLi.parentElement.nodeName) && endSelectionLi.parentElement !== parentOfMainUlorOL) {
            this.domNode.insertAfter(this.openTag(endSelectionLi.parentElement.nodeName), endInsertAfterElement);
            endSelectionLi = endSelectionLi.parentElement;
            endInsertAfterElement = endInsertAfterElement.nextSibling;
            const closeClasses = ['e-rte-list-close-li', 'e-rte-list-close-ol', 'e-rte-list-close-ul'];
            const openClasses = ['e-rte-list-open-ol', 'e-rte-list-open-ul'];
            const hasCloseClass = endInsertAfterElement.previousElementSibling &&
                closeClasses.indexOf(endInsertAfterElement.previousElementSibling.classList[0]) > -1;
            const hasOpenClass = openClasses.indexOf(endInsertAfterElement.classList[0]) > -1;
            if (hasCloseClass && hasOpenClass) {
                // To mark the beginning of a reopened list structure after a selection operation. This class is added
                endInsertAfterElement.classList.add('e-rte-list-start');
            }
        }
    }
    // This Method completely revert the selected List items
    completeRevertList(elements, enterAction = 'P') {
        for (let i = 0; i < elements.commonList.length; i++) {
            // Find the top-most UL/OL/LI ancestor that owns the selection
            const mainParentULorOL = elements.commonListParent[i];
            const classListOfMainUlorOl = mainParentULorOL.getAttribute('class');
            const styleListOfMainUlorOl = mainParentULorOL.getAttribute('style');
            const parentOfMainUlorOL = mainParentULorOL.parentElement;
            // Locate selection start and normalize to its LI container
            const startElement = mainParentULorOL.querySelector('.e-editor-select-start');
            let selectionLi = startElement ? startElement.parentElement : null;
            if (isNOU(selectionLi)) {
                selectionLi = elements.commonList[i];
            }
            while (selectionLi && selectionLi.nodeName !== 'LI') {
                selectionLi = selectionLi.parentElement;
            }
            selectionLi.classList.add('e-rte-select-list-start');
            const startLi = selectionLi;
            this.closeAncestorsBeforeSelection(selectionLi, parentOfMainUlorOL);
            // Locate selection end marker; fallback to start if missing
            let endElement = mainParentULorOL.querySelector('.e-editor-select-end');
            if (isNullOrUndefined(endElement) && elements.commonList.length === 1) {
                endElement = startElement;
            }
            // Normalize to the containing LI for the end marker
            let endSelectionLi = endElement ? endElement.parentElement : null;
            if (isNOU(endSelectionLi)) {
                endSelectionLi = mainParentULorOL.lastElementChild;
                endElement = endSelectionLi.childNodes[endSelectionLi.childNodes.length - 1];
            }
            while (endSelectionLi.nodeName !== 'LI') {
                endSelectionLi = endSelectionLi.parentElement;
            }
            endSelectionLi.classList.add('e-rte-select-list-end');
            const endLi = endSelectionLi;
            // Expand endElement to the nearest block boundary, then to the last inline sibling in that block
            while (!this.parent.domNode.isBlockNode(endElement)) {
                if (endElement.parentElement.tagName !== 'LI') {
                    endElement = endElement.parentElement;
                }
                else {
                    break;
                }
            }
            while (endElement.nextSibling && !this.isListTag(endElement.nextSibling.nodeName)) {
                endElement = endElement.nextSibling;
            }
            if (endElement.nodeName === 'TD' || endElement.nodeName === 'TH') {
                endElement = endLi.childNodes[endLi.childNodes.length - 1];
                while (endElement && this.isListTag(endElement.nodeName)) {
                    endElement = endElement.previousSibling;
                }
            }
            this.closeAncestorsAfterSelection(endElement, endSelectionLi, startLi, endLi, parentOfMainUlorOL);
            mainParentULorOL.outerHTML = this.processSplitedList(this.replaceCustomSpans(mainParentULorOL.outerHTML, classListOfMainUlorOl, styleListOfMainUlorOl), enterAction);
        }
    }
    // This method merges new attributes into an element, avoids duplicates for class and style, removes unnecessary classes and list-related styles, and cleans up empty attributes.
    addAllAttributes(element, attributes) {
        Object.keys(attributes).forEach((key) => {
            const newValue = attributes[key];
            // Check if the attribute already exists
            const existingValue = element.getAttribute(key);
            if (existingValue) {
                // Merge values for attributes like class, style, etc.
                if (key === 'class' || key === 'style') {
                    // Avoid duplicate values
                    const mergedValue = Array.from(new Set((existingValue + ' ' + newValue).trim().split(/\s+/))).join(' ');
                    element.setAttribute(key, mergedValue);
                }
                else {
                    // For other attributes, you can decide to overwrite or merge based on your needs
                    element.setAttribute(key, newValue); // Overwrite by default
                }
            }
            else {
                // If attribute doesn't exist, just set it
                element.setAttribute(key, newValue);
            }
        });
        const classesToRemove = ['e-rte-checklist', 'e-rte-select-list-start', 'e-rte-select-list-end', 'e-rte-checklist-checked'];
        let classRemoved = false;
        classesToRemove.forEach((cls) => {
            if (element.classList.contains(cls)) {
                element.classList.remove(cls);
                classRemoved = true;
            }
        });
        // Remove 'class' attribute if no classes remain
        if (classRemoved && element.classList.length === 0) {
            element.removeAttribute('class');
        }
        if (element.style) {
            const styles = element.style;
            for (let i = 0; i < styles.length; i++) {
                if (styles[i] === 'list-style-image' || styles[i] === 'list-style-type') {
                    element.style.removeProperty(styles[i]);
                    i--;
                }
            }
            if (element.style.length === 0) {
                element.removeAttribute('style');
            }
        }
    }
    // This method processes a split list by wrapping selected items, preserving attributes, cleaning up empty lists, and applying styles before returning the updated HTML content.
    processSplitedList(content, enterAction) {
        const tempElement = createElement('div');
        tempElement.innerHTML = content;
        const startLi = tempElement.querySelector('.e-rte-select-list-start');
        let startElement = startLi;
        let mainUlOlAttributes;
        if (startLi.previousElementSibling && (startLi.previousElementSibling.nodeName === 'OL' || startLi.previousElementSibling.nodeName === 'UL')) {
            mainUlOlAttributes = this.extractAllAttributes(startLi.previousElementSibling);
        }
        if (startLi) {
            // Adding the class for processing the list element
            startLi.classList.add('e-rte-insertAfterElement');
            this.wrapperAction(startLi, enterAction, tempElement, mainUlOlAttributes);
            startElement = startLi.nextElementSibling;
            detach(startLi);
        }
        while (startElement && !(startElement.nodeName === 'OL' || startElement.nodeName === 'UL')) {
            if (startElement.nodeName === 'LI') {
                startElement.classList.add('e-rte-insertAfterElement');
                this.wrapperAction(startElement, enterAction, tempElement, mainUlOlAttributes);
                const nextLi = startElement.nextElementSibling;
                detach(startElement);
                startElement = nextLi;
            }
            else {
                startElement = startElement.nextElementSibling;
            }
        }
        if (startElement.classList.contains('e-rte-checklist')) {
            const ulList = startElement.querySelectorAll('ul');
            for (let i = 0; i < ulList.length; i++) {
                ulList[i].classList.add('e-rte-checklist');
            }
            const liElements = startElement.querySelectorAll('li');
            for (let i = 0; i < liElements.length; i++) {
                if (liElements[i].style.listStyleType === 'none') {
                    liElements[i].classList.add('e-rte-checklist-hidden');
                }
            }
        }
        const element = tempElement.querySelector('.e-rte-insertAfterElement');
        if (element) {
            element.classList.remove('e-rte-insertAfterElement');
            const classAttribute = element.getAttribute('class');
            if (!classAttribute) {
                element.removeAttribute('class');
            }
        }
        // Adding style for nested list of lastly splitted list elements
        this.addStyleForNestedList(tempElement);
        this.clearEmptyList(tempElement);
        return tempElement.innerHTML.trim();
    }
    // This method applies the style of the last nested list to its parent list element if the parent lacks that style, ensuring consistent formatting for deeply nested lists.
    addStyleForNestedList(tempElement) {
        if (tempElement.lastElementChild && (tempElement.lastElementChild.nodeName === 'OL' || tempElement.lastElementChild.nodeName === 'UL')) {
            const lastItem = tempElement.lastElementChild.firstElementChild;
            const textNode = !isNOU(lastItem) ? this.getFirstTextNode(lastItem) : null;
            if (!isNOU(textNode)) {
                let parentOfTextNode = textNode.parentNode;
                if (parentOfTextNode.nodeName !== 'OL' && parentOfTextNode.nodeName !== 'UL') {
                    while (parentOfTextNode && parentOfTextNode.nodeName !== 'LI') {
                        parentOfTextNode = parentOfTextNode.parentElement;
                    }
                    parentOfTextNode = parentOfTextNode.parentElement;
                }
                const styles = lastItem.parentElement.getAttribute('style');
                if ((!parentOfTextNode.getAttribute('style') || !parentOfTextNode.getAttribute('style').includes(styles)) && !isNOU(styles)) {
                    parentOfTextNode.setAttribute('style', styles);
                }
            }
        }
    }
    // This method removes empty <ul>, <ol>, and <li> elements from the container unless they contain media elements, ensuring clean and valid HTML structure.
    clearEmptyList(tempElement) {
        const emptyListElements = tempElement.querySelectorAll('ul, ol');
        for (let i = 0; i < emptyListElements.length; i++) {
            const element = emptyListElements[i];
            const hasMediaElem = element.querySelector('img, video, audio, table');
            const isEmptyText = element.textContent.trim() === '';
            if (isEmptyText && !hasMediaElem) {
                detach(element);
            }
        }
        const emptyList = tempElement.querySelectorAll('li:empty');
        for (let i = 0; i < emptyList.length; i++) {
            detach(emptyList[i]);
        }
    }
    // This method moves the marker class from the current element to its next sibling, ensuring the correct position for subsequent insertions.
    updateInsertAfterMarker(marker) {
        const nextElement = marker.nextElementSibling;
        marker.classList.remove('e-rte-insertAfterElement');
        const classAttribute = marker.getAttribute('class');
        if (!classAttribute) {
            marker.removeAttribute('class');
        }
        if (nextElement) {
            nextElement.classList.add('e-rte-insertAfterElement');
        }
    }
    // This method appends collected inline nodes into a wrapper element (or inserts them with a <br> if needed), places it after the marker in the container, and resets the inline node list.
    flushWrap(wrapElement, inlineNodes, container) {
        if (inlineNodes.length === 0) {
            return [];
        }
        if (wrapElement.nodeName !== 'BR') {
            for (let i = 0; i < inlineNodes.length; i++) {
                wrapElement.appendChild(inlineNodes[i]);
            }
            if (wrapElement.innerHTML.trim() !== '') {
                const marker = container.querySelector('.e-rte-insertAfterElement');
                if (marker) {
                    this.domNode.insertAfter(wrapElement, marker);
                    this.updateInsertAfterMarker(marker);
                }
            }
        }
        else {
            const marker = container.querySelector('.e-rte-insertAfterElement');
            let needToinsertBr = false;
            for (let i = 0; i < inlineNodes.length; i++) {
                if (inlineNodes[i].textContent.trim() !== '') {
                    container.insertBefore(inlineNodes[i], marker);
                    needToinsertBr = true;
                }
            }
            if (needToinsertBr) {
                container.insertBefore(wrapElement, marker);
            }
        }
        return [];
    }
    // This method creates a new wrapper element based on the specified tag (enterAction), applies attributes from the main list and the current element, and returns it for use in wrapping content.
    createWrapElement(enterAction, mainUlOlAttributes, element) {
        const wrapElement = createElement(enterAction);
        if (wrapElement.nodeName !== 'BR') {
            if (!isNOU(mainUlOlAttributes)) {
                this.applyAllAttributes(wrapElement, mainUlOlAttributes);
            }
            const allAttributes = this.extractAllAttributes(element);
            this.addAllAttributes(wrapElement, allAttributes);
        }
        if (wrapElement.getAttribute('style')) {
            const removableStyles = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
            removableStyles.forEach((prop) => {
                if (wrapElement.style.getPropertyValue(prop)) {
                    wrapElement.style.removeProperty(prop);
                }
            });
            // Remove the style attribute if no styles remain
            if (wrapElement.style.length === 0) {
                wrapElement.removeAttribute('style');
            }
        }
        return wrapElement;
    }
    // This method processes the child nodes of a list item, wrapping inline content into blocks, handling nested lists recursively, and preserving attributes for proper structure and formatting.
    wrapperAction(element, enterAction, tempElement, mainUlOlAttributes) {
        const childNodes = Array.from(element.childNodes);
        let inlineNodes = [];
        for (let i = 0; i < childNodes.length; i++) {
            const node = childNodes[i];
            if (node.nodeType === Node.ELEMENT_NODE) {
                const liChildNodes = node;
                if (this.domNode.isBlockNode(liChildNodes) && !this.isListTag(liChildNodes.nodeName)) {
                    // Output collected inline nodes as a wrapped block, then emit the block element
                    const wrapElement = this.createWrapElement(enterAction, mainUlOlAttributes, element);
                    inlineNodes = this.flushWrap(wrapElement, inlineNodes, tempElement);
                    const marker = tempElement.querySelector('.e-rte-insertAfterElement');
                    if (marker) {
                        if (liChildNodes.innerHTML.trim() !== '' || liChildNodes.nodeName === 'HR') {
                            if (!isNOU(mainUlOlAttributes)) {
                                this.addAllAttributes(liChildNodes, mainUlOlAttributes);
                            }
                            let parentLi = liChildNodes.parentElement;
                            while (parentLi && parentLi.nodeName !== 'LI' && parentLi.nodeName !== 'OL' && parentLi.nodeName !== 'UL') {
                                parentLi = parentLi.parentElement;
                            }
                            const allAttributes = this.extractAllAttributes(parentLi);
                            this.addAllAttributes(liChildNodes, allAttributes);
                            this.domNode.insertAfter(liChildNodes, marker);
                            this.updateInsertAfterMarker(marker);
                        }
                    }
                }
                else if (this.isListTag(liChildNodes.nodeName)) {
                    // Finish current inline run, then recurse into nested lists
                    const wrapElement = this.createWrapElement(enterAction, mainUlOlAttributes, element);
                    inlineNodes = this.flushWrap(wrapElement, inlineNodes, tempElement);
                    this.wrapperAction(liChildNodes, enterAction, tempElement, mainUlOlAttributes);
                }
                else {
                    inlineNodes.push(node);
                }
            }
            else {
                inlineNodes.push(node);
            }
        }
        // Flush any remaining inline nodes
        const wrapElement = this.createWrapElement(enterAction, mainUlOlAttributes, element);
        this.flushWrap(wrapElement, inlineNodes, tempElement);
    }
    // This method replaces placeholder <span> tags in the input string with actual <ul>, <ol>, and <li> tags, applying optional classes and styles for proper list rendering.
    replaceCustomSpans(input, mainListClass, mainListStyle) {
        const hasStyle = !isNOU(mainListStyle);
        const hasClass = !isNOU(mainListClass);
        let openUlReplacement = '<ul';
        if (hasClass) {
            openUlReplacement += ' class="' + mainListClass + '"';
        }
        if (hasStyle) {
            openUlReplacement += ' style="' + mainListStyle + '"';
        }
        openUlReplacement += '>';
        let openOlReplacement = '<ol';
        if (hasClass) {
            openOlReplacement += ' class="' + mainListClass + '"';
        }
        if (hasStyle) {
            openOlReplacement += ' style="' + mainListStyle + '"';
        }
        openOlReplacement += '>';
        const openLiReplacement = (!isNOU(mainListClass) && mainListClass.indexOf('e-rte-checklist-hidden') >= 0) ? '<li class="e-rte-checklist-hidden" style="list-style-type: none;">' : '<li style="list-style-type: none;">';
        const replacements = [
            {
                pattern: /<span class="e-rte-list-close-ul"><\/span>/g,
                replacement: '</ul>'
            },
            {
                pattern: /<span class="e-rte-list-close-li"><\/span>/g,
                replacement: '</li>'
            },
            {
                pattern: /<span class="e-rte-list-close-ol"><\/span>/g,
                replacement: '</ol>'
            },
            {
                pattern: /<span class="e-rte-list-open-ul e-rte-list-start"><\/span>/g,
                replacement: openUlReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ol e-rte-list-start"><\/span>/g,
                replacement: openOlReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ul"><\/span>/g,
                replacement: '<ul>'
            },
            {
                pattern: /<span class="e-rte-list-open-li"><\/span>/g,
                replacement: openLiReplacement
            },
            {
                pattern: /<span class="e-rte-list-open-ol"><\/span>/g,
                replacement: '<ol>'
            }
        ];
        let output = input;
        for (let i = 0; i < replacements.length; i++) {
            output = output.replace(replacements[i].pattern, replacements[i].replacement);
        }
        return output;
    }
    revertList(elements, e) {
        const temp = [];
        for (let i = elements.length - 1; i >= 0; i--) {
            for (let j = i - 1; j >= 0; j--) {
                if (elements[j].contains((elements[i])) || elements[j] === elements[i]) {
                    temp.push(elements[i]);
                    elements.splice(i, 1);
                    break;
                }
            }
        }
        this.findUnSelected(temp, elements);
        const viewNode = [];
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            if (this.domNode.contents(element)[0].nodeType === 3 && this.domNode.contents(element)[0].textContent.trim().length === 0) {
                detach(this.domNode.contents(element)[0]);
            }
            let parentNode = elements[i].parentNode;
            let className = element.getAttribute('class');
            if (temp.length === 0) {
                const siblingList = elements[i].querySelectorAll('ul, ol');
                const firstNode = siblingList[0];
                if (firstNode) {
                    const child = firstNode
                        .querySelectorAll('li');
                    if (child) {
                        const nestedElement = createElement(firstNode.tagName);
                        append([nestedElement], firstNode.parentNode);
                        const nestedElementLI = createElement('li', { styles: 'list-style-type: none;' });
                        append([nestedElementLI], nestedElement);
                        append([firstNode], nestedElementLI);
                    }
                }
            }
            if (element.parentNode.insertBefore(this.closeTag(parentNode.tagName), element),
                'LI' === parentNode.parentNode.tagName || 'OL' === parentNode.parentNode.tagName ||
                    'UL' === parentNode.parentNode.tagName) {
                element.parentNode.insertBefore(this.closeTag('LI'), element);
            }
            else {
                let classAttr = '';
                if (className) {
                    // eslint-disable-next-line
                    classAttr += ' class="' + className + '"';
                }
                const closestListMargin = this.getClosestListParentMargin(element);
                if (CONSTANT.DEFAULT_TAG && 0 === element.querySelectorAll(CONSTANT.BLOCK_TAGS.join(', ')).length) {
                    const wrapperclass = isNullOrUndefined(className) ? ' class="e-rte-wrap-inner"' :
                        ' class="' + className + ' e-rte-wrap-inner"';
                    const parentElement = parentNode;
                    if (elements.length === parentElement.querySelectorAll('li').length) {
                        if (!isNOU(parentElement.style.listStyleType)) {
                            parentNode.style.removeProperty('list-style-type');
                        }
                        if (!isNOU(parentElement.style.listStyleImage)) {
                            parentNode.style.removeProperty('list-style-image');
                        }
                        if (parentElement.style.length === 0) {
                            parentNode.removeAttribute('style');
                        }
                    }
                    const wrapperTag = isNullOrUndefined(e.enterAction) ? CONSTANT.DEFAULT_TAG : e.enterAction;
                    const targetElement = element;
                    if (targetElement.getAttribute('style')) {
                        const removableStyles = ['color', 'font-size', 'font-family', 'font-weight', 'font-style'];
                        removableStyles.forEach((prop) => {
                            if (targetElement.style.getPropertyValue(prop)) {
                                targetElement.style.removeProperty(prop);
                            }
                        });
                        // Remove the style attribute if no styles remain
                        if (targetElement.style.length === 0) {
                            targetElement.removeAttribute('style');
                        }
                    }
                    const wrapper = '<' + wrapperTag + wrapperclass + this.domNode.attributes(element) + '></' + wrapperTag + '>';
                    const tempElement = document.createElement('div');
                    tempElement.innerHTML = wrapper;
                    if (closestListMargin !== '') {
                        tempElement.firstElementChild.style.marginLeft = closestListMargin;
                    }
                    if (e.enterAction !== 'BR') {
                        this.domNode.wrapInner(element, this.domNode.parseHTMLFragment(tempElement.innerHTML));
                    }
                    else if (element.textContent !== '') {
                        const wrapperSpan = '<span class=e-rte-wrap-inner id=removeSpan></span>';
                        const br = document.createElement('br');
                        this.domNode.wrapInner(element, this.domNode.parseHTMLFragment(wrapperSpan));
                        element.appendChild(br);
                    }
                }
                else if (this.domNode.contents(element)[0].nodeType === 3) {
                    const replace = this.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, this.parent.domNode.encode(this.domNode.contents(element)[0].textContent));
                    this.domNode.replaceWith(this.domNode.contents(element)[0], replace);
                }
                else if (this.domNode.contents(element)[0].classList.contains(markerClassName.startSelection) ||
                    this.domNode.contents(element)[0].classList.contains(markerClassName.endSelection)) {
                    let replace = this.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, '<br>' + this.domNode.contents(element)[0].outerHTML);
                    if (this.domNode.contents(element)[1] && this.domNode.contents(element)[1].tagName === 'BR') {
                        this.domNode.contents(element)[1].remove();
                        replace = this.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, '<br>' + this.domNode.contents(element)[0].outerHTML);
                    }
                    else {
                        replace = this.domNode.createTagString(CONSTANT.DEFAULT_TAG, parentNode, this.domNode.contents(element)[0].outerHTML);
                    }
                    this.domNode.replaceWith(this.domNode.contents(element)[0], replace);
                }
                else {
                    const childNode = element.firstChild;
                    if (childNode) {
                        const attributes = element.parentElement.attributes;
                        if (attributes.length > 0) {
                            for (let d = 0; d < attributes.length; d++) {
                                const e = attributes[d];
                                const clean = (v) => v ? v.split(';').filter((s) => !/list-style-(image|type):/.test(s.trim())).join(';').trim() : '';
                                const existingValue = clean(childNode.getAttribute(e.nodeName));
                                const parentValue = clean(element.parentElement.getAttribute(e.nodeName));
                                if (existingValue && existingValue !== parentValue) {
                                    childNode.setAttribute(e.nodeName, existingValue ? parentValue + ' ' + existingValue : parentValue);
                                }
                                else {
                                    childNode.setAttribute(e.nodeName, parentValue);
                                }
                                if (childNode.style.length === 0) {
                                    childNode.removeAttribute('style');
                                }
                            }
                        }
                    }
                    className = childNode.getAttribute('class');
                    if (className && childNode.getAttribute('class') && className !== childNode.getAttribute('class')) {
                        attributes(childNode, { 'class': className + ' ' + childNode.getAttribute('class') });
                    }
                }
                append([this.openTag('LI')], element);
                prepend([this.closeTag('LI')], element);
            }
            this.domNode.insertAfter(this.openTag(parentNode.tagName), element);
            if (parentNode.parentNode.tagName === 'LI') {
                parentNode = parentNode.parentNode.parentNode;
            }
            if (viewNode.indexOf(parentNode) < 0) {
                viewNode.push(parentNode);
            }
        }
        for (let i = 0; i < viewNode.length; i++) {
            const node = viewNode[i];
            let nodeInnerHtml = node.innerHTML;
            const closeTag = /<span class="e-rte-list-close-([a-z]*)"><\/span>/g;
            const openTag = /<span class="e-rte-list-open-([a-z]*)"><\/span>/g;
            nodeInnerHtml = nodeInnerHtml.replace(closeTag, '</$1>');
            nodeInnerHtml = nodeInnerHtml.replace(openTag, '<$1 ' + this.domNode.attributes(node) + '>');
            this.domNode.replaceWith(node, this.domNode.openTagString(node) + nodeInnerHtml.trim() + this.domNode.closeTagString(node));
        }
        const emptyUl = this.parent.editableElement.querySelectorAll('ul:empty, ol:empty');
        for (let i = 0; i < emptyUl.length; i++) {
            detach(emptyUl[i]);
        }
        const emptyLi = this.parent.editableElement.querySelectorAll('li:empty');
        for (let i = 0; i < emptyLi.length; i++) {
            detach(emptyLi[i]);
        }
        this.revertCheckListClasses();
    }
    revertCheckListClasses() {
        const searchContainer = this.parent.editableElement;
        const checkListElements = searchContainer.querySelectorAll('.e-rte-checklist');
        checkListElements.forEach((element) => {
            if (element.nodeName !== 'UL' && element.classList.contains('e-rte-checklist')) {
                removeClass([element], ['e-rte-checklist']);
                if (element.getAttribute('class') === '') {
                    element.removeAttribute('class');
                }
            }
        });
        const checkedListContainers = searchContainer.querySelectorAll('.e-rte-checklist-checked');
        checkedListContainers.forEach((element) => {
            if (element.nodeName !== 'LI') {
                removeClass([element], ['e-rte-checklist-checked']);
                if (element.getAttribute('class') === '') {
                    element.removeAttribute('class');
                }
            }
        });
    }
    getClosestListParentMargin(element) {
        let current = element;
        while (current && current !== this.parent.editableElement) {
            if (current.nodeName === 'UL' || current.nodeName === 'OL') {
                return current.style.marginLeft;
            }
            current = current.parentElement;
        }
        return '';
    }
    openTag(type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-open-' + type.toLowerCase() + '"></span>');
    }
    closeTag(type) {
        return this.domNode.parseHTMLFragment('<span class="e-rte-list-close-' + type.toLowerCase() + '"></span>');
    }
    destroy() {
        this.removeEventListener();
        if (this.domNode) {
            this.domNode = null;
        }
    }
    areAllListItemsSelected(list, range) {
        const listItems = list.querySelectorAll('li');
        for (let i = 0; i < listItems.length; i++) {
            const listItem = listItems[i];
            const listItemRange = this.parent.currentDocument.createRange();
            listItemRange.selectNodeContents(listItem);
            if (!range.intersectsNode(listItem)) {
                return false;
            }
        }
        return true;
    }
    getListCursorInfo(range) {
        let position;
        let selectionState;
        const domMethods = new DOMMethods(this.parent.editableElement);
        const startNode = range.startContainer.nodeType === Node.TEXT_NODE ?
            domMethods.getTopMostNode(range.startContainer) : range.startContainer;
        const endNode = range.endContainer.nodeType === Node.TEXT_NODE ?
            domMethods.getTopMostNode(range.endContainer) : range.endContainer;
        const isSelection = !range.collapsed;
        const startList = startNode.nodeType === Node.TEXT_NODE ? startNode.parentElement.closest('li') :
            startNode.closest('li');
        const endList = endNode.nodeType === Node.TEXT_NODE ? endNode.parentElement.closest('li') :
            endNode.closest('li');
        const isNestedStart = startList && startList.closest('ol, ul') ? this.checkIsNestedList(startList.closest('ol, ul')) : false;
        const isNestedEnd = endList && endList.closest('ol, ul') ? this.checkIsNestedList(endList.closest('ol, ul')) : false;
        const blockNodes = this.parent.domNode.blockNodes();
        const length = blockNodes.length;
        const itemType = this.getListSelectionType(isNestedStart ? 'Nested' : 'Parent', isNestedEnd ? 'Nested' : 'Parent');
        if (isSelection) {
            if (blockNodes.length === 1) {
                selectionState = range.startOffset === 0 && range.endOffset === startList.textContent.length ? 'SingleFull' : 'SinglePartial';
            }
            else {
                selectionState = range.startOffset === 0 && range.endOffset === blockNodes[length - 1].textContent.length ? 'MultipleFull' : 'MultiplePartial';
            }
            position = 'None';
        }
        else {
            if (range.startOffset === 0 && startNode.previousSibling === null) {
                position = isNestedStart ? 'StartNested' : 'StartParent';
            }
            else if (range.startOffset === startList.textContent.length && startNode.nextSibling === null) {
                position = isNestedStart ? 'EndNested' : 'EndParent';
            }
            else {
                position = isNestedStart ? 'MiddleNested' : 'MiddleParent';
            }
            selectionState = 'None';
        }
        return { position, selectionState, itemType };
    }
    checkIsNestedList(listParent) {
        const isDirectParent = listParent.parentElement === this.parent.editableElement;
        if (isDirectParent) { // Check if the list is directly under the editable element.
            return false;
        }
        if (listParent.closest('li')) {
            return true;
        }
        return false;
    }
    getListSelectionType(start, end) {
        if (start === 'Nested' && end === 'Nested') {
            return 'Nested';
        }
        else if (start === 'Parent' && end === 'Parent') {
            return 'Parent';
        }
        else {
            return 'Mixed';
        }
    }
    isAllListNodesSelected(list) {
        const selection = this.parent.currentDocument.getSelection();
        let isAllSelected = false;
        const liNodes = list.querySelectorAll('li');
        for (let i = 0; i < liNodes.length; i++) {
            if (selection.containsNode(liNodes[i], false)) {
                isAllSelected = true;
            }
            else {
                isAllSelected = false;
                break;
            }
        }
        return isAllSelected;
    }
    formatListStyle(listStyle) {
        // Handle known lowercase patterns like "lowergreek"
        const knownPattern = /^(lower|upper)(greek|alpha|roman)$/i;
        if (knownPattern.test(listStyle)) {
            return listStyle.replace(knownPattern, (_, p1, p2) => `${p1}-${p2}`).toLowerCase();
        }
        // Handle camelCase like "lowerGreek"
        return listStyle.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
}
